var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useRef, useState, useMemo } from "react";
import store from "../../reduxStore/store";
import { GetProductDataService, getLoggedInRepDetails } from "../../services/apiServices/salesRepDataService";
import { dataAddingOnCart, gettingCartData, GetCompanyLocationPricelist, GetCompanyLocationQuantityRule } from "../../reduxStore/actions/salesRepDataAction";
import { SalesRepDataActionType } from "../../reduxStore/actions/actionTypes";
import { isLoading } from "../../services/behaviorSubjectService";
import { useTranslation } from "react-i18next";
import { SharedFunctions, getDiscountTypeFromValueType } from "../SharedFunctions";
import { EDIT_ORDER_FLAG } from "../Constant";
export function B2BProductTableBL() {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var dispatch = useDispatch();
    var t = useTranslation().t; //* Translation *
    var debounce = SharedFunctions().debounce;
    var _p = getLoggedInRepDetails(), shopCurrency = _p.shopCurrency, currency = _p.currency;
    var salesRepData = useSelector(function (state) { return (state.salesRepData ? state.salesRepData : {}); });
    var _q = useState(""), productSearchText = _q[0], setProductSearchText = _q[1];
    var _r = useState(false), searchTablePopupOpen = _r[0], setSearchTablePopupOpen = _r[1];
    var _s = useState(false), viewPricingPopupOpen = _s[0], setViewPricingPopupOpen = _s[1];
    var _t = useState(""), productName = _t[0], setProductName = _t[1];
    var _u = useState(""), productVariantID = _u[0], setProductVariantID = _u[1];
    var _v = useState(false), getProductsLoading = _v[0], setGetProductsLoading = _v[1];
    var _w = useState([]), productsArray = _w[0], setProductsArray = _w[1];
    var _x = useState([]), selectedProductArray = _x[0], setSelectedProductArray = _x[1];
    var _y = useState([]), selectedProductIdArray = _y[0], setSelectedProductIdArray = _y[1];
    var _z = useState([]), selectedVariantArray = _z[0], setSelectedVariantArray = _z[1];
    var _0 = useState({}), netQuantitySubtotal = _0[0], setNetQuantitySubtotal = _0[1];
    var _1 = useState(0), totalOrderAmount = _1[0], setTotalOrderAmount = _1[1];
    var _2 = useState([]), finalSelectedProducts = _2[0], setFinalSelectedProducts = _2[1];
    var _3 = useState(false), uncheckedFlag = _3[0], setUncheckedFlag = _3[1];
    // Make selectedCompanyLocationId reactive using useSelector
    var customerDetailsCreateInvoice = useSelector(function () { var _a; return (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.customerDetailsCreateInvoice; });
    var selectedCompanyLocationId = customerDetailsCreateInvoice === null || customerDetailsCreateInvoice === void 0 ? void 0 : customerDetailsCreateInvoice.locationId;
    var _4 = useState(), pageInfo = _4[0], setPageInfo = _4[1];
    var propsFromCreateOrderParentTab = true;
    var isUpdatedCart = (_a = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.editDraftOrder) === null || _a === void 0 ? void 0 : _a.isUpdatedCart;
    var isEditOrder = ((_b = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.editDraftOrder) === null || _b === void 0 ? void 0 : _b.actionEvent) === EDIT_ORDER_FLAG;
    // In edit mode, use location_id from draft order if customerDetailsCreateInvoice is not yet populated
    var editOrderLocationId = isEditOrder ? (_e = (_d = (_c = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.editDraftOrder) === null || _c === void 0 ? void 0 : _c.draftOrderObj) === null || _d === void 0 ? void 0 : _d.b2bCompany) === null || _e === void 0 ? void 0 : _e.location_id : null;
    var effectiveLocationId = selectedCompanyLocationId || editOrderLocationId;
    var createOrderTabReduxState = (_f = useSelector(function () { return store.getState().salesRepData.createOrderTab; })) !== null && _f !== void 0 ? _f : {};
    var _5 = useState({ msg: "", open: false, severity: "error" }), alertErrorMsg = _5[0], setAlertErrorMsg = _5[1];
    var _6 = useState({}), isQuantityError = _6[0], setIsQuantityError = _6[1];
    var storefrontAccessToken = (_g = store.getState().salesRepData.baseData) === null || _g === void 0 ? void 0 : _g.storefrontAccessToken;
    var locationPricelistData = (_h = useSelector(function () { var _a, _b; return (_b = (_a = store.getState()) === null || _a === void 0 ? void 0 : _a.salesRepData) === null || _b === void 0 ? void 0 : _b.locationPricelistData; })) !== null && _h !== void 0 ? _h : {};
    // Helper to get location data (handles both numeric and GraphQL ID formats)
    var getLocationData = useCallback(function () {
        if (!effectiveLocationId)
            return null;
        var numericData = locationPricelistData[effectiveLocationId];
        var graphqlData = locationPricelistData["gid://shopify/CompanyLocation/".concat(effectiveLocationId)];
        return numericData || graphqlData || null;
    }, [effectiveLocationId, locationPricelistData]);
    // Make B2BPriceList reactive using useMemo so it updates when effectiveLocationId or locationPricelistData changes
    var B2BPriceList = useMemo(function () {
        var locationData = getLocationData();
        return locationData === null || locationData === void 0 ? void 0 : locationData.priceList;
    }, [effectiveLocationId, locationPricelistData, getLocationData]);
    var _7 = useState([]), searchProduct_Ids = _7[0], setSearchedProduct_Ids = _7[1];
    var _8 = useState(false), isRemoveCartPopup = _8[0], setIsRemoveCartPopup = _8[1];
    var _9 = useState(false), loadMoreBtnDisable = _9[0], setLoadMoreBtnDisable = _9[1];
    var _10 = useState(false), isProductLoaded = _10[0], setIsProductLoaded = _10[1];
    var selectFeature = salesRepData.baseData.select ? salesRepData.baseData.select : {};
    var ShopApplyDiscount = ((_j = selectFeature === null || selectFeature === void 0 ? void 0 : selectFeature.featuresAdditionalSettings) === null || _j === void 0 ? void 0 : _j.showB2BApplyDiscount) ? (_k = selectFeature === null || selectFeature === void 0 ? void 0 : selectFeature.featuresAdditionalSettings) === null || _k === void 0 ? void 0 : _k.showB2BApplyDiscount : false;
    var _11 = useState({}), discount_idObject = _11[0], setDiscount_idObject = _11[1];
    var _12 = useState({}), isDiscountError = _12[0], setIsDiscountError = _12[1];
    var _13 = useState(false), discountsManuallyReset = _13[0], setDiscountsManuallyReset = _13[1];
    var previousDraftOrderIdRef = useRef(null);
    var _14 = useState("percentage"), selectedDiscountType = _14[0], setSelectedDiscountType = _14[1];
    var _15 = useState("percentage"), pendingDiscountType = _15[0], setPendingDiscountType = _15[1];
    var _16 = useState(false), discountAlertBox = _16[0], setDiscountAlertBox = _16[1];
    var _17 = useState(0), masterSubTotal = _17[0], setMasterSubTotal = _17[1];
    var tableContainerRef = useRef(null);
    var isCustomerDetails = ((_l = Object === null || Object === void 0 ? void 0 : Object.keys(customerDetailsCreateInvoice)) === null || _l === void 0 ? void 0 : _l.length) === 0;
    var _18 = useState(null), hoveredIconIndex = _18[0], setHoveredIconIndex = _18[1];
    var _19 = useState(false), loadMoreProducts = _19[0], setLoadMoreProducts = _19[1];
    //Update Cart or Cart.json
    var productAddOnCart = function (params, Type, updateVariants) { return __awaiter(_this, void 0, void 0, function () {
        var variantsAndQuantityArray, _a, response_GetCart, variantIdsArray, variantIdsSetArray_1, variant_Id, CartErrorRespose, error_1;
        var _b, _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    _a = Type;
                    switch (_a) {
                        case "add.js": return [3 /*break*/, 1];
                        case "update.js": return [3 /*break*/, 3];
                        case "change.js": return [3 /*break*/, 4];
                        case "clear.js": return [3 /*break*/, 5];
                    }
                    return [3 /*break*/, 6];
                case 1: return [4 /*yield*/, dispatch(gettingCartData())];
                case 2:
                    response_GetCart = _h.sent();
                    variantIdsArray = (_c = (_b = response_GetCart === null || response_GetCart === void 0 ? void 0 : response_GetCart.data) === null || _b === void 0 ? void 0 : _b.items) === null || _c === void 0 ? void 0 : _c.map(function (item) { return item === null || item === void 0 ? void 0 : item.variant_id; });
                    variantIdsSetArray_1 = new Set(variantIdsArray);
                    variantsAndQuantityArray = params === null || params === void 0 ? void 0 : params.reduce(function (acc, item) {
                        var _a;
                        var variantId = Number((_a = item === null || item === void 0 ? void 0 : item.variantId) === null || _a === void 0 ? void 0 : _a.split("gid://shopify/ProductVariant/")[1]);
                        if (!(variantIdsSetArray_1 === null || variantIdsSetArray_1 === void 0 ? void 0 : variantIdsSetArray_1.has(variantId))) {
                            acc.push({
                                id: variantId,
                                quantity: (item === null || item === void 0 ? void 0 : item.quantity) || 1,
                            });
                        }
                        return acc;
                    }, []);
                    return [3 /*break*/, 7];
                case 3:
                    variantsAndQuantityArray = updateVariants;
                    return [3 /*break*/, 7];
                case 4:
                    variant_Id = Number((_d = updateVariants === null || updateVariants === void 0 ? void 0 : updateVariants.variantId) === null || _d === void 0 ? void 0 : _d.split("gid://shopify/ProductVariant/")[1]);
                    variantsAndQuantityArray = { id: variant_Id === null || variant_Id === void 0 ? void 0 : variant_Id.toString(), quantity: updateVariants === null || updateVariants === void 0 ? void 0 : updateVariants.quantity };
                    return [3 /*break*/, 7];
                case 5:
                    variantsAndQuantityArray = {};
                    return [3 /*break*/, 7];
                case 6:
                    variantsAndQuantityArray = {};
                    _h.label = 7;
                case 7:
                    isLoading.next(true);
                    if (!((variantsAndQuantityArray && ((_e = Object.keys(variantsAndQuantityArray)) === null || _e === void 0 ? void 0 : _e.length) > 0) || Type === "clear.js")) return [3 /*break*/, 11];
                    _h.label = 8;
                case 8:
                    _h.trys.push([8, 10, , 11]);
                    return [4 /*yield*/, dispatch(dataAddingOnCart(variantsAndQuantityArray, Type))];
                case 9:
                    CartErrorRespose = _h.sent();
                    isLoading.next(false);
                    if (typeof CartErrorRespose === "boolean" && CartErrorRespose) {
                        return [2 /*return*/, true];
                    }
                    else {
                        if ((_f = CartErrorRespose === null || CartErrorRespose === void 0 ? void 0 : CartErrorRespose.toLowerCase()) === null || _f === void 0 ? void 0 : _f.includes("can't add more")) {
                            setAlertErrorMsg({ msg: t("createOrder_ErrorMsgForQuantityLimit"), open: true });
                        }
                        else if ((_g = CartErrorRespose === null || CartErrorRespose === void 0 ? void 0 : CartErrorRespose.toLowerCase()) === null || _g === void 0 ? void 0 : _g.includes("cannot find")) {
                            setAlertErrorMsg({ msg: t("ST_Producttable_CartResponse"), open: true });
                        }
                        else {
                            setAlertErrorMsg({ msg: CartErrorRespose, open: true });
                        }
                        return [2 /*return*/, false];
                    }
                    return [3 /*break*/, 11];
                case 10:
                    error_1 = _h.sent();
                    return [2 /*return*/, false];
                case 11:
                    isLoading.next(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var debouncedProductAddOnCart = useCallback(debounce(productAddOnCart, 600), []);
    // Populate cart when editing B2B draft order
    var handleB2BEditOrderCartUpdate = function () { return __awaiter(_this, void 0, void 0, function () {
        var editOrderReduxData, availableProducts, variantsAndQuantityArray, i, variantIdStr, numericVariantId, responseClearCart, responseAddCart, updateReduxState, error_2;
        var _a, _b, _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    _h.trys.push([0, 5, , 6]);
                    if (!isEditOrder || isUpdatedCart) {
                        return [2 /*return*/];
                    }
                    editOrderReduxData = (_b = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.editDraftOrder) !== null && _b !== void 0 ? _b : {};
                    availableProducts = (_c = editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.productDetailsArray) !== null && _c !== void 0 ? _c : [];
                    if (availableProducts.length === 0) {
                        return [2 /*return*/];
                    }
                    variantsAndQuantityArray = [];
                    for (i = 0; i < availableProducts.length; i++) {
                        if (((_d = availableProducts[i]) === null || _d === void 0 ? void 0 : _d.variantId) && ((_e = availableProducts[i]) === null || _e === void 0 ? void 0 : _e.quantity)) {
                            variantIdStr = availableProducts[i].variantId.toString();
                            numericVariantId = variantIdStr.includes("gid://shopify/ProductVariant/")
                                ? variantIdStr.split("gid://shopify/ProductVariant/")[1]
                                : variantIdStr;
                            if (numericVariantId && !isNaN(Number(numericVariantId))) {
                                variantsAndQuantityArray.push({
                                    id: Number(numericVariantId),
                                    quantity: (_g = (_f = availableProducts[i]) === null || _f === void 0 ? void 0 : _f.quantity) !== null && _g !== void 0 ? _g : 0,
                                });
                            }
                        }
                    }
                    if (variantsAndQuantityArray.length === 0) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, dispatch(dataAddingOnCart({}, "clear.js"))];
                case 1:
                    responseClearCart = _h.sent();
                    if (!(typeof responseClearCart === "boolean" && responseClearCart === true)) return [3 /*break*/, 3];
                    return [4 /*yield*/, dispatch(dataAddingOnCart(variantsAndQuantityArray, "add.js"))];
                case 2:
                    responseAddCart = _h.sent();
                    if (typeof responseAddCart === "boolean" && responseAddCart === true) {
                        updateReduxState = {
                            payload: __assign(__assign({}, editOrderReduxData), { isUpdatedCart: true }),
                            type: SalesRepDataActionType.EDIT_DRAFT_ORDER,
                        };
                        dispatch(updateReduxState);
                    }
                    else {
                        setAlertErrorMsg({
                            msg: responseAddCart === "Request failed with status code 404" ? t("customerInvoice_EditOrder_ErrorMsgForCartUpdate") : responseAddCart,
                            open: true,
                            severity: "error",
                        });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    setAlertErrorMsg({
                        msg: responseClearCart === "Request failed with status code 404" ? t("customerInvoice_EditOrder_ErrorMsgForCartUpdate") : responseClearCart,
                        open: true,
                        severity: "error",
                    });
                    _h.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    error_2 = _h.sent();
                    console.error("Error in handleB2BEditOrderCartUpdate:", error_2);
                    setAlertErrorMsg({ msg: t("customerInvoice_EditOrder_ErrorMsgForCartUpdate"), open: true, severity: "error" });
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    // Use ref to prevent multiple pricelist fetches for the same location
    var hasFetchedPricelistRef = useRef({});
    // Debounce the "missing from price list" banner dispatch so it doesn't flicker while the
    // price list is still being fetched/merged across multiple re-runs of handleMakeFormatArray
    var missingPriceListBannerTimerRef = useRef(null);
    // Fetch locationPricelistData when editing B2B draft order (if not already available)
    // Follow the same pattern as CreateB2BOrderSharedActionsBL.tsx
    useEffect(function () {
        var _a;
        try {
            if (isEditOrder && editOrderLocationId) {
                // Check both numeric and GraphQL ID formats
                var locationDataNumeric = locationPricelistData === null || locationPricelistData === void 0 ? void 0 : locationPricelistData[editOrderLocationId];
                var locationDataGraphQL = locationPricelistData === null || locationPricelistData === void 0 ? void 0 : locationPricelistData["gid://shopify/CompanyLocation/".concat(editOrderLocationId)];
                var locationData = locationDataNumeric || locationDataGraphQL;
                var hasPricelist = (locationData === null || locationData === void 0 ? void 0 : locationData.priceList) && ((_a = Object.keys(locationData.priceList)) === null || _a === void 0 ? void 0 : _a.length) > 0;
                var alreadyFetched = hasFetchedPricelistRef.current[editOrderLocationId];
                // Only fetch if:
                // 1. We haven't fetched for this location yet, AND
                // 2. Location data doesn't exist OR pricelist is empty
                if (!alreadyFetched && (!locationData || !hasPricelist)) {
                    hasFetchedPricelistRef.current[editOrderLocationId] = true;
                    dispatch(GetCompanyLocationPricelist(editOrderLocationId, "", false, isProductLoaded));
                }
                else if (hasPricelist) {
                    // Mark as fetched if pricelist is already loaded
                    hasFetchedPricelistRef.current[editOrderLocationId] = true;
                }
            }
        }
        catch (error) {
            console.error("Error in useEffect for fetching locationPricelistData:", error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isEditOrder, editOrderLocationId]);
    // Populate cart when editing B2B draft order (only once)
    useEffect(function () {
        var _a, _b, _c;
        try {
            if (isEditOrder && !isUpdatedCart) {
                var editOrderReduxData = (_b = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.editDraftOrder) !== null && _b !== void 0 ? _b : {};
                var productDetailsArray = (_c = editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.productDetailsArray) !== null && _c !== void 0 ? _c : [];
                // Only proceed if we have product data
                if (productDetailsArray.length > 0) {
                    handleB2BEditOrderCartUpdate();
                }
            }
        }
        catch (error) {
            console.error("Error in useEffect for cart update:", error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isEditOrder, isUpdatedCart, (_m = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.editDraftOrder) === null || _m === void 0 ? void 0 : _m.productDetailsArray]);
    // Helper: Convert variant ID to GraphQL format if needed
    var convertVariantIdToGraphQL = function (variantId) {
        if (!variantId)
            return null;
        var variantIdStr = variantId.toString();
        if (variantIdStr.includes("gid://shopify/ProductVariant/")) {
            return variantIdStr;
        }
        return "gid://shopify/ProductVariant/".concat(variantIdStr);
    };
    // Helper: Get subtotal discount from draft order
    var getSubtotalDiscount = function (draftOrder) {
        var appliedDiscount = draftOrder === null || draftOrder === void 0 ? void 0 : draftOrder.applied_discount;
        var discountValue = (appliedDiscount === null || appliedDiscount === void 0 ? void 0 : appliedDiscount.value) != null && (appliedDiscount === null || appliedDiscount === void 0 ? void 0 : appliedDiscount.value) !== undefined
            ? appliedDiscount.value || 0
            : undefined;
        var discountType = getDiscountTypeFromValueType(appliedDiscount);
        return { value: discountValue, discountType: discountType };
    };
    // Helper: Extract and validate line item discounts
    // Returns both the discounts object and tracks discount types
    var extractLineItemDiscounts = function (lineItems) {
        var lineItemDiscounts = {};
        var hasDollarDiscount = false;
        var hasPercentageDiscount = false;
        if (!lineItems || !Array.isArray(lineItems)) {
            return { discounts: lineItemDiscounts, hasDollarDiscount: hasDollarDiscount, hasPercentageDiscount: hasPercentageDiscount };
        }
        lineItems.forEach(function (variant) {
            var _a;
            var variantId = convertVariantIdToGraphQL(variant === null || variant === void 0 ? void 0 : variant.variant_id);
            var discountValue = (_a = variant === null || variant === void 0 ? void 0 : variant.applied_discount) === null || _a === void 0 ? void 0 : _a.value;
            if (variantId && discountValue != null && discountValue !== undefined) {
                // Determine discount type from value_type (always check value_type first)
                var lineItemDiscountType = getDiscountTypeFromValueType(variant.applied_discount);
                // Track discount type for dropdown
                if (lineItemDiscountType === "dollar") {
                    hasDollarDiscount = true;
                }
                else {
                    hasPercentageDiscount = true;
                }
                // Extract all discounts - don't filter by selectedVariantArray here
                // The discount will be applied when the variant is ready in netQuantitySubtotal
                // Ensure consistent string format for all discount values (matching API expectation)
                lineItemDiscounts[variantId] = String(discountValue);
            }
        });
        return { discounts: lineItemDiscounts, hasDollarDiscount: hasDollarDiscount, hasPercentageDiscount: hasPercentageDiscount };
    };
    // Helper: Calculate discounted price based on discount type and value
    var calculateDiscountedPrice = function (basePrice, discountValue, discountType) {
        if (isNaN(discountValue)) {
            return { discountedPrice: basePrice, isValid: false };
        }
        if (discountType === "percentage") {
            if (discountValue > 0 && discountValue <= 100) {
                var discountedPrice = parseFloat((basePrice - (basePrice * discountValue) / 100).toFixed(2));
                return { discountedPrice: discountedPrice, isValid: true };
            }
        }
        else {
            // dollar discount
            if (discountValue >= 0 && discountValue <= basePrice) {
                var discountedPrice = parseFloat((basePrice - discountValue).toFixed(2));
                return { discountedPrice: discountedPrice, isValid: true };
            }
        }
        return { discountedPrice: basePrice, isValid: false };
    };
    // Helper: Update netQuantitySubtotal with discounted prices
    var updateNetQuantitySubtotalWithDiscounts = function (lineItemDiscounts, discountType) {
        setNetQuantitySubtotal(function (prevNetQuantitySubtotal) {
            var updatedNetQuantitySubtotal = __assign({}, prevNetQuantitySubtotal);
            Object.keys(lineItemDiscounts).forEach(function (variantId) {
                var _a, _b, _c;
                // Apply discount if variant exists in netQuantitySubtotal (even if not in selectedVariantArray yet)
                if (updatedNetQuantitySubtotal[variantId]) {
                    var variant = selectedVariantArray.find(function (v) { return v.variantId === variantId; });
                    var basePrice = ((_a = updatedNetQuantitySubtotal[variantId]) === null || _a === void 0 ? void 0 : _a.price) || (variant === null || variant === void 0 ? void 0 : variant.variantPrice) || 0;
                    var quantity = ((_b = updatedNetQuantitySubtotal[variantId]) === null || _b === void 0 ? void 0 : _b.quantity) || 1;
                    var discountValue = parseFloat((_c = lineItemDiscounts[variantId]) === null || _c === void 0 ? void 0 : _c.toString());
                    if (!Number.isNaN(discountValue) && discountValue > 0 && basePrice > 0) {
                        var _d = calculateDiscountedPrice(basePrice, discountValue, discountType), discountedPrice = _d.discountedPrice, isValid = _d.isValid;
                        var subtotal = isValid
                            ? parseFloat((discountedPrice * quantity).toFixed(2))
                            : basePrice * quantity;
                        updatedNetQuantitySubtotal[variantId] = __assign(__assign({}, updatedNetQuantitySubtotal[variantId]), { discountedPrice: discountedPrice, subtotal: subtotal });
                    }
                }
            });
            return updatedNetQuantitySubtotal;
        });
    };
    // Helper: Dispatch discount data to Redux
    var dispatchDiscountToRedux = function (discountObject, discountType) {
        var action = {
            payload: {
                selectedProductData: selectedVariantArray || [],
                isQuantityError: isQuantityError,
                isDiscountError: isDiscountError,
                discountKeyValueObject: discountObject,
                selectedDiscountType: discountType,
            },
            type: SalesRepDataActionType.PRODUCT_TABLE_DATA,
        };
        dispatch(action);
    };
    // Patch discount values from edit order data (similar to regular order flow)
    // IMPORTANT: This should run AFTER products are loaded from cart and netQuantitySubtotal is populated
    // Only patch if discounts are not already set in state (to prevent overwriting user edits)
    useEffect(function () {
        var _a, _b;
        try {
            if (!isEditOrder || !isUpdatedCart || selectedVariantArray.length === 0 || Object.keys(netQuantitySubtotal).length === 0) {
                return;
            }
            var editOrderReduxData = (_b = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.editDraftOrder) !== null && _b !== void 0 ? _b : {};
            var draftOrder = editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.draftOrderObj;
            if (!draftOrder) {
                return;
            }
            // Reset manual reset flag when draftOrder.id changes (new order loaded)
            // This allows discounts to be loaded for new orders
            var currentDraftOrderId = draftOrder === null || draftOrder === void 0 ? void 0 : draftOrder.id;
            if (currentDraftOrderId && previousDraftOrderIdRef.current !== currentDraftOrderId) {
                // New order loaded - reset the flag
                setDiscountsManuallyReset(false);
                previousDraftOrderIdRef.current = currentDraftOrderId;
            }
            // Check if discounts were manually reset - if so, don't re-load from draftOrder
            // (Similar to regular order: when user confirms discount type change, discounts are cleared
            // and we don't want to reload them from draftOrder)
            if (discountsManuallyReset) {
                // Discounts were manually reset - don't reload from draftOrder
                return;
            }
            // Check if discounts are already set in state - if so, don't re-patch (user may have edited them)
            var hasExistingDiscounts = Object.keys(discount_idObject).length > 0;
            if (hasExistingDiscounts) {
                // Discounts already exist in state - don't overwrite
                return;
            }
            // Get subtotal discount and discount type
            var _c = getSubtotalDiscount(draftOrder), appliedDiscountOnSubTotal = _c.value, orderDiscountType = _c.discountType;
            // Extract line item discounts and track discount types
            var _d = extractLineItemDiscounts(draftOrder === null || draftOrder === void 0 ? void 0 : draftOrder.line_items), lineItemDiscounts = _d.discounts, lineItemHasDollar = _d.hasDollarDiscount, lineItemHasPercentage = _d.hasPercentageDiscount;
            // Track discount types to determine dropdown type at the end
            var hasDollarDiscount = lineItemHasDollar;
            var hasPercentageDiscount = lineItemHasPercentage;
            // Check order-level discount type
            if (appliedDiscountOnSubTotal !== undefined && appliedDiscountOnSubTotal !== null) {
                if (orderDiscountType === "dollar") {
                    hasDollarDiscount = true;
                }
                else {
                    hasPercentageDiscount = true;
                }
            }
            // Set discount type dropdown at the end based on what was found
            // If we have any dollar discounts, use dollar; otherwise if we have percentage discounts, use percentage
            var finalDiscountType = "percentage"; // default
            if (hasDollarDiscount) {
                finalDiscountType = "dollar";
            }
            else if (hasPercentageDiscount) {
                finalDiscountType = "percentage";
            }
            // Set the dropdown type
            setSelectedDiscountType(finalDiscountType);
            // Create discount object - ensure consistent formatting (all as strings)
            var discountObject = __assign({}, lineItemDiscounts);
            if (appliedDiscountOnSubTotal !== undefined && appliedDiscountOnSubTotal !== null) {
                // discountOnSubTotal should be a string for consistency with line item discounts
                discountObject.discountOnSubTotal = String(appliedDiscountOnSubTotal);
            }
            // Apply discounts if any exist - only if state is empty
            if (Object.keys(discountObject).length > 0) {
                setDiscount_idObject(discountObject);
                updateNetQuantitySubtotalWithDiscounts(lineItemDiscounts, finalDiscountType);
                dispatchDiscountToRedux(discountObject, finalDiscountType);
            }
        }
        catch (error) {
            console.error("Error in useEffect for discount patching:", error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isEditOrder, isUpdatedCart, selectedVariantArray, netQuantitySubtotal, (_o = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.editDraftOrder) === null || _o === void 0 ? void 0 : _o.draftOrderObj]);
    // Read from cart ONLY for edit orders after cart is populated
    // For new orders, don't auto-read cart - user will manually add products
    // Cart products should show even if locationPricelistData isn't loaded yet - don't block on it
    useEffect(function () {
        try {
            // Only read cart for edit orders, not for new orders
            // For new orders, user will manually select company and add products
            if (!isEditOrder) {
                return; // New order - don't auto-read cart, let user add products manually
            }
            // Edit order flow: wait for cart to be populated
            if (!effectiveLocationId) {
                return; // No location selected, cannot proceed
            }
            // Edit order: wait for cart to be populated (isUpdatedCart = true)
            if (isUpdatedCart) {
                readCartProducts();
            }
        }
        catch (error) {
            console.error("Error in useEffect for reading cart products:", error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isUpdatedCart, effectiveLocationId, locationPricelistData, isEditOrder]);
    useEffect(function () {
        setFinalSelectedProducts(selectedProductArray);
    }, [uncheckedFlag]);
    useEffect(function () {
        if (!searchTablePopupOpen) {
            var UpdatedSubtotal = calculateTotalVariantPrices(netQuantitySubtotal);
            setMasterSubTotal(UpdatedSubtotal);
            setTotalOrderAmount(UpdatedSubtotal);
            if (ShopApplyDiscount) {
                applyDiscountInSubtotale(UpdatedSubtotal);
            }
        }
    }, [netQuantitySubtotal, finalSelectedProducts, discount_idObject]);
    useEffect(function () {
        setFinalSelectedProducts([]);
        setFinalSelectedProducts(function (prevState) {
            var newState = __spreadArray(__spreadArray([], prevState, true), selectedProductArray, true);
            debouncedProductAddOnCart(selectedVariantArray, "add.js", newState);
            return newState;
        });
    }, [selectedProductArray, debouncedProductAddOnCart]);
    useEffect(function () {
        var _a, _b;
        if (netQuantitySubtotal && ((_a = Object.keys(netQuantitySubtotal)) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            (_b = Object.keys(netQuantitySubtotal)) === null || _b === void 0 ? void 0 : _b.forEach(function (variantId) {
                var foundVariant = selectedVariantArray.find(function (item) { return variantId === (item === null || item === void 0 ? void 0 : item.variantId); });
                updateSubtotal(variantId, foundVariant === null || foundVariant === void 0 ? void 0 : foundVariant.variantPrice);
            });
        }
    }, [createOrderTabReduxState]);
    useEffect(function () {
        handleQuantityAndReduxStateUpdate();
    }, [netQuantitySubtotal, isQuantityError, isDiscountError]);
    useEffect(function () {
        if (isCustomerDetails) {
            removeAllSelectedProducts();
        }
    }, [isCustomerDetails]);
    var updateSubtotal = function (variantId, variantPrice) {
        try {
            var updateResult = UpdateSubTotalWithB2BData(variantId, variantPrice);
            if (updateResult && updateResult != null) {
                var variantMinQuantity_1 = updateResult.variantMinQuantity, updatedVariantSubTotal_1 = updateResult.updatedVariantSubTotal, B2BCatalogPrice = updateResult.B2BCatalogPrice;
                var B2BPrice_1 = B2BCatalogPrice ? B2BCatalogPrice : variantPrice;
                if (ShopApplyDiscount) {
                    setNetQuantitySubtotal(function (prevNetQuantitySubtotal) {
                        var _a;
                        var _b, _c, _d, _e, _f;
                        var subtotal = updatedVariantSubTotal_1; // ✅ use already computed subtotal
                        var discountExists = discount_idObject === null || discount_idObject === void 0 ? void 0 : discount_idObject.hasOwnProperty(variantId);
                        if (discountExists) {
                            var discountAmount = parseFloat((_b = (discount_idObject[variantId] || 0)) === null || _b === void 0 ? void 0 : _b.toString());
                            var quantity = variantMinQuantity_1;
                            if (selectedDiscountType === "percentage" && discountAmount >= 0 && discountAmount <= 100) {
                                var discountedPrice = parseFloat((_c = (B2BPrice_1 - (B2BPrice_1 * discountAmount) / 100)) === null || _c === void 0 ? void 0 : _c.toFixed(2));
                                subtotal = parseFloat((_d = (discountedPrice * quantity)) === null || _d === void 0 ? void 0 : _d.toFixed(2));
                            }
                            else if (selectedDiscountType !== "percentage" && discountAmount >= 0 && discountAmount <= B2BPrice_1) {
                                // Fixed Amount discount: discountAmount is per-unit discount
                                // Apply per-unit discount: (price - perUnitDiscount) × quantity
                                var unitDiscountedPrice = parseFloat((_e = (B2BPrice_1 - discountAmount)) === null || _e === void 0 ? void 0 : _e.toFixed(2));
                                subtotal = parseFloat((_f = (unitDiscountedPrice * quantity)) === null || _f === void 0 ? void 0 : _f.toFixed(2));
                            }
                        }
                        return __assign(__assign({}, prevNetQuantitySubtotal), (_a = {}, _a[variantId] = __assign(__assign({}, prevNetQuantitySubtotal[variantId]), { price: B2BPrice_1, quantity: variantMinQuantity_1, subtotal: subtotal, QuantityPriceBreaks: getB2BQuantityPriceBreaks(variantId), QuantityRule: getB2BQuantityRule(variantId) }), _a));
                    });
                }
                else {
                    setNetQuantitySubtotal(function (prevNetQuantitySubtotal) {
                        var _a;
                        return __assign(__assign({}, prevNetQuantitySubtotal), (_a = {}, _a[variantId] = __assign(__assign({}, prevNetQuantitySubtotal[variantId]), { price: B2BPrice_1, quantity: variantMinQuantity_1, subtotal: updatedVariantSubTotal_1, QuantityPriceBreaks: getB2BQuantityPriceBreaks(variantId), QuantityRule: getB2BQuantityRule(variantId) }), _a));
                    });
                }
            }
        }
        catch (error) {
            return null;
        }
    };
    var UpdateSubTotalWithB2BData = function (variantId, variantPrice) {
        var _a, _b;
        if (locationPricelistData && ((_a = Object.keys(locationPricelistData)) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var variantMinQuantity = ((_b = netQuantitySubtotal[variantId]) === null || _b === void 0 ? void 0 : _b.quantity) || 1;
            var updatedVariantSubTotal = Number(variantMinQuantity) * variantPrice;
            var b2bDataQuantityPriceBreaks = getB2BQuantityPriceBreaks(variantId);
            var b2bDataQuantityRule = getB2BQuantityRule(variantId);
            var B2BCatalogPrice = getB2BPrice(variantId);
            if (b2bDataQuantityRule != null) {
                variantMinQuantity = B2BMinQuantityRule(b2bDataQuantityRule, variantMinQuantity);
            }
            if (b2bDataQuantityPriceBreaks && (b2bDataQuantityPriceBreaks === null || b2bDataQuantityPriceBreaks === void 0 ? void 0 : b2bDataQuantityPriceBreaks.length) > 0) {
                updatedVariantSubTotal = B2BUpdatedSubTotal(variantMinQuantity, b2bDataQuantityPriceBreaks, updatedVariantSubTotal);
            }
            return { variantMinQuantity: variantMinQuantity, updatedVariantSubTotal: updatedVariantSubTotal, B2BCatalogPrice: B2BCatalogPrice };
        }
        return null;
    };
    var handleSearchProductData = function (companyLocationId, firstCall) { return __awaiter(_this, void 0, void 0, function () {
        var reduxLocationPricelistData, companyLocationCatalogCursorDetails_1, priceList, productIds, _a, _b, newProducts, newPageInfo, updatedProducts, error_3;
        var _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    _h.trys.push([0, 2, , 3]);
                    if (!firstCall) {
                        setLoadMoreProducts(true);
                    }
                    reduxLocationPricelistData = ((_c = store.getState().salesRepData) === null || _c === void 0 ? void 0 : _c.locationPricelistData) || {};
                    companyLocationCatalogCursorDetails_1 = (_d = reduxLocationPricelistData[companyLocationId]) === null || _d === void 0 ? void 0 : _d.companyLocationCatalogCursorDetails;
                    priceList = (_e = reduxLocationPricelistData[companyLocationId]) === null || _e === void 0 ? void 0 : _e.priceList;
                    productIds = priceList ? Array.from(new Set((_f = Object.values(priceList)) === null || _f === void 0 ? void 0 : _f.map(function (item) { return item === null || item === void 0 ? void 0 : item.productId; }))) : [];
                    return [4 /*yield*/, GetProductDataService(productSearchText, storefrontAccessToken, "", "", undefined, productIds)];
                case 1:
                    _a = _h.sent(), _b = _a.products, newProducts = _b === void 0 ? [] : _b, newPageInfo = _a.pageInfo;
                    updatedProducts = __spreadArray(__spreadArray([], productsArray, true), newProducts === null || newProducts === void 0 ? void 0 : newProducts.filter(function (newProduct) { return !productsArray.some(function (prevProduct) { return prevProduct.productId === newProduct.productId; }); }), true);
                    // If locationPricelistData is available, update with B2B price list
                    if (locationPricelistData && ((_g = Object.keys(locationPricelistData)) === null || _g === void 0 ? void 0 : _g.length) > 0) {
                        updateProductsWithB2bPriceList(updatedProducts);
                    }
                    // Update page information if available
                    if (companyLocationCatalogCursorDetails_1) {
                        setPageInfo(function (prevPageInfo) { return (__assign(__assign({}, prevPageInfo), { endCursor: (companyLocationCatalogCursorDetails_1 === null || companyLocationCatalogCursorDetails_1 === void 0 ? void 0 : companyLocationCatalogCursorDetails_1.ProductsEndCursor) || "", quantityEndCursor: (companyLocationCatalogCursorDetails_1 === null || companyLocationCatalogCursorDetails_1 === void 0 ? void 0 : companyLocationCatalogCursorDetails_1.QuantityEndCursor) || "", pricesEndCursor: (companyLocationCatalogCursorDetails_1 === null || companyLocationCatalogCursorDetails_1 === void 0 ? void 0 : companyLocationCatalogCursorDetails_1.PricesEndCursor) || "" })); });
                    }
                    if (!firstCall) {
                        setLoadMoreProducts(false);
                    }
                    return [2 /*return*/, updatedProducts];
                case 2:
                    error_3 = _h.sent();
                    if (!firstCall) {
                        setLoadMoreProducts(false);
                    }
                    return [2 /*return*/, []];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var updateProductDataWithSearhedValue = function (companyLocationId, newProducts) { return __awaiter(_this, void 0, void 0, function () {
        var reduxLocationPricelistData, companyLocationCatalogCursorDetails_2, priceList, productIds_1, updatedProducts;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
            try {
                reduxLocationPricelistData = ((_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.locationPricelistData) || {};
                companyLocationCatalogCursorDetails_2 = (_b = reduxLocationPricelistData[companyLocationId]) === null || _b === void 0 ? void 0 : _b.companyLocationCatalogCursorDetails;
                priceList = (_c = reduxLocationPricelistData[companyLocationId]) === null || _c === void 0 ? void 0 : _c.priceList;
                if (priceList) {
                    productIds_1 = priceList ? Array.from(new Set((_d = Object.values(priceList)) === null || _d === void 0 ? void 0 : _d.map(function (item) { return item === null || item === void 0 ? void 0 : item.productId; }))) : [];
                    updatedProducts = newProducts === null || newProducts === void 0 ? void 0 : newProducts.filter(function (product) { return productIds_1 === null || productIds_1 === void 0 ? void 0 : productIds_1.includes(product === null || product === void 0 ? void 0 : product.productId); });
                    updateProductsWithB2bPriceList(updatedProducts);
                    setProductsArray((updatedProducts === null || updatedProducts === void 0 ? void 0 : updatedProducts.length) > 0 ? updatedProducts : newProducts);
                }
                // Update page information if available
                if (companyLocationCatalogCursorDetails_2) {
                    setPageInfo(function (prevPageInfo) { return (__assign(__assign({}, prevPageInfo), { SearchPricesEndCursor: companyLocationCatalogCursorDetails_2 === null || companyLocationCatalogCursorDetails_2 === void 0 ? void 0 : companyLocationCatalogCursorDetails_2.SearchPricesEndCursor })); });
                }
            }
            catch (error) {
                return [2 /*return*/, []];
            }
            return [2 /*return*/];
        });
    }); };
    var handleSearchCatalogProduct = function (searchedvalue, startCursor, endCursor, makeEmpty) { return __awaiter(_this, void 0, void 0, function () {
        var locationId, reduxLocationPricelistData, companyLocationCatalogCursorDetails, allProducts, hasNextPage, currentEndCursor, _a, newProducts, newPageInfo, updatedSearchedProducts, arrayOfProductIds, stringiFiedObject, error_4;
        var _b, _c, _d, _e, _f, _g;
        return __generator(this, function (_h) {
            switch (_h.label) {
                case 0:
                    _h.trys.push([0, 9, , 10]);
                    searchedvalue = searchedvalue === null || searchedvalue === void 0 ? void 0 : searchedvalue.trim();
                    setLoadMoreProducts(true);
                    locationId = (_d = (_c = (_b = store.getState()) === null || _b === void 0 ? void 0 : _b.salesRepData) === null || _c === void 0 ? void 0 : _c.customerDetailsCreateInvoice) === null || _d === void 0 ? void 0 : _d.locationId;
                    if (!locationId) return [3 /*break*/, 8];
                    reduxLocationPricelistData = ((_e = store.getState().salesRepData) === null || _e === void 0 ? void 0 : _e.locationPricelistData) || {};
                    companyLocationCatalogCursorDetails = (_f = reduxLocationPricelistData[locationId]) === null || _f === void 0 ? void 0 : _f.companyLocationCatalogCursorDetails;
                    allProducts = [];
                    hasNextPage = true;
                    currentEndCursor = endCursor;
                    _h.label = 1;
                case 1:
                    if (!(hasNextPage && (allProducts === null || allProducts === void 0 ? void 0 : allProducts.length) < 30)) return [3 /*break*/, 3];
                    return [4 /*yield*/, GetProductDataService(makeEmpty === "" ? makeEmpty : searchedvalue, storefrontAccessToken, startCursor, currentEndCursor).then(function (data) { return data; })];
                case 2:
                    _a = _h.sent(), newProducts = _a.products, newPageInfo = _a.pageInfo;
                    // Store fetched products
                    allProducts = __spreadArray(__spreadArray([], allProducts, true), newProducts, true);
                    // Update pagination info
                    hasNextPage = (newPageInfo === null || newPageInfo === void 0 ? void 0 : newPageInfo.hasNextPage) && (newPageInfo === null || newPageInfo === void 0 ? void 0 : newPageInfo.endCursor) !== currentEndCursor;
                    currentEndCursor = newPageInfo === null || newPageInfo === void 0 ? void 0 : newPageInfo.endCur;
                    return [3 /*break*/, 1];
                case 3:
                    updatedSearchedProducts = filterProductsForSpecificSearch(searchedvalue, allProducts);
                    if (!(reduxLocationPricelistData && ((_g = Object.keys(reduxLocationPricelistData)) === null || _g === void 0 ? void 0 : _g.length) > 0 && (updatedSearchedProducts === null || updatedSearchedProducts === void 0 ? void 0 : updatedSearchedProducts.length) > 0)) return [3 /*break*/, 7];
                    arrayOfProductIds = updatedSearchedProducts === null || updatedSearchedProducts === void 0 ? void 0 : updatedSearchedProducts.map(function (product) { var _a; return (_a = product === null || product === void 0 ? void 0 : product.productId) === null || _a === void 0 ? void 0 : _a.replace("gid://shopify/Product/", ""); });
                    if (!(arrayOfProductIds && (arrayOfProductIds === null || arrayOfProductIds === void 0 ? void 0 : arrayOfProductIds.length) > 0)) return [3 /*break*/, 5];
                    setSearchedProduct_Ids(arrayOfProductIds);
                    setIsProductLoaded(false);
                    companyLocationCatalogCursorDetails = __assign(__assign({}, companyLocationCatalogCursorDetails), { SearchedProductIds: arrayOfProductIds });
                    stringiFiedObject = JSON.stringify(companyLocationCatalogCursorDetails);
                    return [4 /*yield*/, dispatch(GetCompanyLocationPricelist(locationId, stringiFiedObject, true, false))];
                case 4:
                    _h.sent();
                    updateProductDataWithSearhedValue(locationId, updatedSearchedProducts);
                    return [3 /*break*/, 6];
                case 5:
                    setSearchedProduct_Ids([]);
                    _h.label = 6;
                case 6: return [3 /*break*/, 8];
                case 7:
                    setProductsArray(updatedSearchedProducts);
                    _h.label = 8;
                case 8:
                    setLoadMoreProducts(false);
                    return [3 /*break*/, 10];
                case 9:
                    error_4 = _h.sent();
                    setLoadMoreProducts(false);
                    return [2 /*return*/, []];
                case 10: return [2 /*return*/];
            }
        });
    }); };
    var filterProductsForSpecificSearch = function (searchValue, newProductsArray) {
        var _a, _b, _c;
        var lowerCasedSearchWords = (_c = (_b = (_a = searchValue === null || searchValue === void 0 ? void 0 : searchValue.trim()) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.split(" ")) === null || _c === void 0 ? void 0 : _c.map(function (word) { return word === null || word === void 0 ? void 0 : word.trim(); });
        var filteredProducts = newProductsArray === null || newProductsArray === void 0 ? void 0 : newProductsArray.filter(function (product) {
            var _a, _b, _c, _d, _e;
            var title = ((_b = (_a = product === null || product === void 0 ? void 0 : product.title) === null || _a === void 0 ? void 0 : _a.trim()) === null || _b === void 0 ? void 0 : _b.toLowerCase()) || "";
            var handle = ((_d = (_c = product === null || product === void 0 ? void 0 : product.handle) === null || _c === void 0 ? void 0 : _c.trim()) === null || _d === void 0 ? void 0 : _d.toLowerCase()) || "";
            var variantMatches = (_e = product === null || product === void 0 ? void 0 : product.variants) === null || _e === void 0 ? void 0 : _e.some(function (variant) {
                var _a, _b, _c, _d;
                var variantTitle = ((_b = (_a = variant === null || variant === void 0 ? void 0 : variant.title) === null || _a === void 0 ? void 0 : _a.trim()) === null || _b === void 0 ? void 0 : _b.toLowerCase()) || "";
                var variantSku = ((_d = (_c = variant === null || variant === void 0 ? void 0 : variant.sku) === null || _c === void 0 ? void 0 : _c.trim()) === null || _d === void 0 ? void 0 : _d.toLowerCase()) || "";
                return (lowerCasedSearchWords === null || lowerCasedSearchWords === void 0 ? void 0 : lowerCasedSearchWords.every(function (word) { return variantTitle.includes(word); })) || (lowerCasedSearchWords === null || lowerCasedSearchWords === void 0 ? void 0 : lowerCasedSearchWords.every(function (word) { return variantSku.includes(word); }));
            });
            return ((lowerCasedSearchWords === null || lowerCasedSearchWords === void 0 ? void 0 : lowerCasedSearchWords.every(function (word) { return title.includes(word); })) || // Check if all words exist in title
                (lowerCasedSearchWords === null || lowerCasedSearchWords === void 0 ? void 0 : lowerCasedSearchWords.every(function (word) { return handle.includes(word); })) || // Check if all words exist in handle
                variantMatches // Check variants
            );
        });
        return filteredProducts;
    };
    var debouncedSearchedProducts = useCallback(debounce(handleSearchCatalogProduct, 1000), []);
    var updateProductsWithB2bPriceList = function (products) {
        var _a, _b;
        var priceList = (_a = locationPricelistData[effectiveLocationId]) === null || _a === void 0 ? void 0 : _a.priceList;
        // Filter products to include only those present in the price list
        return (products &&
            ((_b = products === null || products === void 0 ? void 0 : products.filter(function (product) { return priceList && Object.values(priceList).some(function (item) { return (item === null || item === void 0 ? void 0 : item.productId) === (product === null || product === void 0 ? void 0 : product.productId); }); })) === null || _b === void 0 ? void 0 : _b.map(function (product) {
                var _a;
                return (__assign(__assign({}, product), { variants: (_a = product === null || product === void 0 ? void 0 : product.variants) === null || _a === void 0 ? void 0 : _a.map(function (variant) {
                        var _a;
                        var b2bData = (_a = priceList === null || priceList === void 0 ? void 0 : priceList[variant.variantId]) === null || _a === void 0 ? void 0 : _a.price;
                        return __assign(__assign({}, variant), { variantPrice: b2bData ? b2bData : variant === null || variant === void 0 ? void 0 : variant.variantPrice });
                    }) }));
            })));
    };
    var handlePrevClick = function () {
        var _a;
        // handleSearchProductData(selectedCompanyLocationId);
        (_a = tableContainerRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo(0, 0);
    };
    var handleNextClick = function () { return __awaiter(_this, void 0, void 0, function () {
        var scrollPosition_1, reduxLocationPricelistData, companyLocationCatalogCursorDetails, isSearchProductAPICall, stringiFiedObject, productsFetched, error_5;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!(pageInfo.endCursor || (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.SearchPricesEndCursor))) return [3 /*break*/, 6];
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 4, 5, 6]);
                    setLoadMoreProducts(true);
                    scrollPosition_1 = ((_a = tableContainerRef.current) === null || _a === void 0 ? void 0 : _a.scrollTop) || 0;
                    reduxLocationPricelistData = ((_b = store.getState().salesRepData) === null || _b === void 0 ? void 0 : _b.locationPricelistData) || {};
                    companyLocationCatalogCursorDetails = (_c = reduxLocationPricelistData[selectedCompanyLocationId]) === null || _c === void 0 ? void 0 : _c.companyLocationCatalogCursorDetails;
                    isSearchProductAPICall = false;
                    if (productSearchText !== "" && (searchProduct_Ids === null || searchProduct_Ids === void 0 ? void 0 : searchProduct_Ids.length) > 0 && (companyLocationCatalogCursorDetails === null || companyLocationCatalogCursorDetails === void 0 ? void 0 : companyLocationCatalogCursorDetails.SearchPricesEndCursor)) {
                        isSearchProductAPICall = true;
                        companyLocationCatalogCursorDetails = __assign(__assign({}, companyLocationCatalogCursorDetails), { SearchedProductIds: searchProduct_Ids });
                    }
                    else {
                        isSearchProductAPICall = false;
                    }
                    stringiFiedObject = JSON.stringify(companyLocationCatalogCursorDetails);
                    return [4 /*yield*/, dispatch(GetCompanyLocationPricelist(selectedCompanyLocationId, stringiFiedObject, isSearchProductAPICall, false))];
                case 2:
                    _d.sent();
                    return [4 /*yield*/, handleSearchProductData(selectedCompanyLocationId)];
                case 3:
                    productsFetched = _d.sent();
                    setProductsArray(productsFetched);
                    // Restore scroll position after data loads
                    setTimeout(function () {
                        if (tableContainerRef.current) {
                            tableContainerRef.current.scrollTop = scrollPosition_1;
                        }
                    }, 0);
                    return [3 /*break*/, 6];
                case 4:
                    error_5 = _d.sent();
                    setLoadMoreProducts(false);
                    console.error("Error in handleNextClick:", error_5);
                    return [3 /*break*/, 6];
                case 5:
                    setLoadMoreProducts(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var handleViewPricingPopup = function (productName, productVariantid) {
        setProductName(productName);
        setProductVariantID(productVariantid);
        setViewPricingPopupOpen(!viewPricingPopupOpen);
    };
    var handleProductTableSearchPopup = function () { return __awaiter(_this, void 0, void 0, function () {
        var productsFetched;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!isCustomerDetails) return [3 /*break*/, 3];
                    setGetProductsLoading(true);
                    setSearchTablePopupOpen(true);
                    return [4 /*yield*/, dispatch(GetCompanyLocationPricelist(selectedCompanyLocationId, "", false, isProductLoaded))];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, handleSearchProductData(selectedCompanyLocationId, true)];
                case 2:
                    productsFetched = _a.sent();
                    setProductsArray(productsFetched);
                    setGetProductsLoading(false);
                    // THis state is only idetifily API call
                    setIsProductLoaded(true);
                    return [3 /*break*/, 4];
                case 3:
                    setAlertErrorMsg({ msg: "Please select Customer for adding product", open: true, severity: "warning" });
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var closePopupForSearchProductData = function () {
        setSearchTablePopupOpen(false);
        setGetProductsLoading(false);
        // makeFieldsEmpty();
        setProductSearchText("");
        setSearchedProduct_Ids([]);
    };
    var makeFieldsEmpty = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setProductSearchText("");
            setSearchedProduct_Ids([]);
            if (productSearchText != "") {
                updateProductTableWithReduxData();
            }
            return [2 /*return*/];
        });
    }); };
    var updateProductTableWithReduxData = function () { return __awaiter(_this, void 0, void 0, function () {
        var productsFetched;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setGetProductsLoading(true);
                    return [4 /*yield*/, dispatch(GetCompanyLocationPricelist(selectedCompanyLocationId, "", false, isProductLoaded))];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, handleSearchProductData(selectedCompanyLocationId, true)];
                case 2:
                    productsFetched = _a.sent();
                    setProductsArray(productsFetched);
                    setGetProductsLoading(false);
                    // THis state is only idetifily API call
                    setIsProductLoaded(true);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSearchTextChange = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var value;
        return __generator(this, function (_a) {
            value = e.target.value;
            setProductSearchText(value);
            debouncedSearchedProducts(value);
            return [2 /*return*/];
        });
    }); };
    var handleKeyDown = function (event) {
        if (event.key === "Enter" && event.keyCode === 13) {
            debouncedSearchedProducts(productSearchText);
        }
    };
    // Function to toggle the selection of a variant
    function checkUncheckProductVariant(event, type, product, variant, uncheckFromSelected) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function () {
            var checked, tempVariantsObj_1, filteredVariants, existingProductIndex, updatedSelectedData, updatedNetQuantitySubtotal, updatedSelectedVariantObject, updatedNetQuantitySubtotal_1, updates_1, variantMinQuantity_2, variantPrice_1, b2bDataQuantityRule_1, b2bDataQuantityPriceBreaks_1, tempVariants_1, updatedNetQuantitySubtotal, updates_2, variantId, error_6;
            var _e, _f;
            var _this = this;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _g.trys.push([0, 6, , 7]);
                        checked = (event === null || event === void 0 ? void 0 : event.target).checked;
                        if (!(type === "isProduct")) return [3 /*break*/, 4];
                        tempVariantsObj_1 = product === null || product === void 0 ? void 0 : product.variants;
                        if (!checked) return [3 /*break*/, 1];
                        filteredVariants = tempVariantsObj_1 === null || tempVariantsObj_1 === void 0 ? void 0 : tempVariantsObj_1.filter(function (variant) { return variant.availableForSale; });
                        if (selectedProductArray === null || selectedProductArray === void 0 ? void 0 : selectedProductArray.some(function (item) { return item.productId === product.productId; })) {
                            existingProductIndex = selectedProductArray.findIndex(function (item) { return item.productId === product.productId; });
                            if (existingProductIndex !== -1) {
                                updatedSelectedData = __spreadArray([], selectedProductArray, true);
                                updatedSelectedData[existingProductIndex].variants = filteredVariants;
                                setSelectedProductArray(updatedSelectedData);
                            }
                        }
                        else {
                            // Product not present, add it with the new variant
                            setSelectedProductArray(__spreadArray(__spreadArray([], selectedProductArray, true), [__assign(__assign({}, product), { variants: filteredVariants })], false));
                            setSelectedProductIdArray(__spreadArray(__spreadArray([], selectedProductIdArray, true), [product.productId], false));
                        }
                        setSelectedVariantArray(__spreadArray(__spreadArray([], selectedVariantArray, true), filteredVariants, true));
                        updatedNetQuantitySubtotal = __assign({}, netQuantitySubtotal);
                        setNetQuantitySubtotal(UpdateQuantityWithB2BQuantityRule(updatedNetQuantitySubtotal, filteredVariants));
                        return [3 /*break*/, 3];
                    case 1:
                        // Uncheck product
                        setUncheckedFlag(!uncheckedFlag);
                        setSelectedProductArray(selectedProductArray === null || selectedProductArray === void 0 ? void 0 : selectedProductArray.filter(function (item) { return item.productId !== (product === null || product === void 0 ? void 0 : product.productId); }));
                        setSelectedProductIdArray(selectedProductIdArray === null || selectedProductIdArray === void 0 ? void 0 : selectedProductIdArray.filter(function (id) { return id !== product.productId; }));
                        updatedSelectedVariantObject = selectedVariantArray === null || selectedVariantArray === void 0 ? void 0 : selectedVariantArray.filter(function (selectedVariant) { return !(tempVariantsObj_1 === null || tempVariantsObj_1 === void 0 ? void 0 : tempVariantsObj_1.some(function (tempVariant) { return (tempVariant === null || tempVariant === void 0 ? void 0 : tempVariant.variantId) === (selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.variantId); })); });
                        setSelectedVariantArray(updatedSelectedVariantObject);
                        if (!uncheckFromSelected) return [3 /*break*/, 3];
                        updatedNetQuantitySubtotal_1 = __assign({}, netQuantitySubtotal);
                        updates_1 = {};
                        tempVariantsObj_1 === null || tempVariantsObj_1 === void 0 ? void 0 : tempVariantsObj_1.forEach(function (variantToRemove) {
                            var _a;
                            delete updatedNetQuantitySubtotal_1[variantToRemove === null || variantToRemove === void 0 ? void 0 : variantToRemove.variantId];
                            if (ShopApplyDiscount) {
                                delete discount_idObject[variantToRemove === null || variantToRemove === void 0 ? void 0 : variantToRemove.variantId];
                            }
                            var variantId = Number((_a = variantToRemove === null || variantToRemove === void 0 ? void 0 : variantToRemove.variantId) === null || _a === void 0 ? void 0 : _a.split("gid://shopify/ProductVariant/")[1]);
                            updates_1[variantId] = 0;
                        });
                        return [4 /*yield*/, productAddOnCart("", "update.js", updates_1)];
                    case 2:
                        _g.sent();
                        setDiscount_idObject(__assign(__assign({}, discount_idObject), (_e = {}, _e["discountOnSubTotal"] = "0", _e)));
                        setNetQuantitySubtotal(updatedNetQuantitySubtotal_1);
                        _g.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        if (checked) {
                            // isVariant
                            if (!(selectedProductArray === null || selectedProductArray === void 0 ? void 0 : selectedProductArray.some(function (item) { return (item === null || item === void 0 ? void 0 : item.productId) === (product === null || product === void 0 ? void 0 : product.productId); }))) {
                                // Product not present, add it with the new variant
                                setSelectedProductArray(__spreadArray(__spreadArray([], selectedProductArray, true), [__assign(__assign({}, product), { variants: [variant] })], false));
                                setSelectedProductIdArray(__spreadArray(__spreadArray([], selectedProductIdArray, true), [product.productId], false));
                            }
                            else {
                                // Product already exists, update the variants array
                                setSelectedProductArray(function (prevSelectedData) {
                                    return prevSelectedData === null || prevSelectedData === void 0 ? void 0 : prevSelectedData.map(function (item) { return (item.productId === product.productId ? __assign(__assign({}, item), { variants: __spreadArray(__spreadArray([], item.variants, true), [variant], false) }) : item); });
                                });
                            }
                            setSelectedVariantArray(__spreadArray(__spreadArray([], selectedVariantArray, true), [variant], false));
                            if (locationPricelistData && ((_a = Object.keys(locationPricelistData)) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                                variantMinQuantity_2 = 1;
                                variantPrice_1 = (_c = (_b = B2BPriceList === null || B2BPriceList === void 0 ? void 0 : B2BPriceList[variant === null || variant === void 0 ? void 0 : variant.variantId]) === null || _b === void 0 ? void 0 : _b.price) !== null && _c !== void 0 ? _c : variant === null || variant === void 0 ? void 0 : variant.variantPrice;
                                b2bDataQuantityRule_1 = getB2BQuantityRule(variant === null || variant === void 0 ? void 0 : variant.variantId);
                                b2bDataQuantityPriceBreaks_1 = getB2BQuantityPriceBreaks(variant === null || variant === void 0 ? void 0 : variant.variantId);
                                if (b2bDataQuantityRule_1 != null) {
                                    variantMinQuantity_2 = B2BMinQuantityRule(b2bDataQuantityRule_1, variantMinQuantity_2);
                                }
                                // Update net quantity subtotal
                                setNetQuantitySubtotal(function (prevNetQuantitySubtotal) {
                                    var _a;
                                    return (__assign(__assign({}, prevNetQuantitySubtotal), (_a = {}, _a[variant === null || variant === void 0 ? void 0 : variant.variantId] = {
                                        price: variantPrice_1,
                                        quantity: variantMinQuantity_2,
                                        subtotal: Number(variantMinQuantity_2) * variantPrice_1,
                                        QuantityPriceBreaks: b2bDataQuantityPriceBreaks_1,
                                        QuantityRule: b2bDataQuantityRule_1,
                                    }, _a)));
                                });
                            }
                        }
                        else {
                            // Uncheck variant
                            setUncheckedFlag(!uncheckedFlag);
                            setSelectedVariantArray(function (prevSelectedVariantObject) { return prevSelectedVariantObject === null || prevSelectedVariantObject === void 0 ? void 0 : prevSelectedVariantObject.filter(function (v) { return v.variantId !== variant.variantId; }); });
                            setSelectedProductArray(function (prevSelectedData) {
                                return prevSelectedData === null || prevSelectedData === void 0 ? void 0 : prevSelectedData.map(function (item) { var _a; return item.productId === product.productId ? __assign(__assign({}, item), { variants: (_a = item.variants) === null || _a === void 0 ? void 0 : _a.filter(function (v) { return v.variantId !== variant.variantId; }) }) : item; });
                            });
                            tempVariants_1 = product === null || product === void 0 ? void 0 : product.variants;
                            setSelectedVariantArray(function (prevSelectedVariantObject) {
                                var variantFoundInSelectedArray = tempVariants_1 === null || tempVariants_1 === void 0 ? void 0 : tempVariants_1.some(function (tempVariant) {
                                    return prevSelectedVariantObject === null || prevSelectedVariantObject === void 0 ? void 0 : prevSelectedVariantObject.some(function (selectedVariant) { return selectedVariant.variantId === tempVariant.variantId; });
                                });
                                if (!variantFoundInSelectedArray) {
                                    setSelectedProductIdArray(function (prevSelectedProductIdObject) { return prevSelectedProductIdObject === null || prevSelectedProductIdObject === void 0 ? void 0 : prevSelectedProductIdObject.filter(function (id) { return id !== product.productId; }); });
                                    setSelectedProductArray(function (prevSelectedData) { return prevSelectedData === null || prevSelectedData === void 0 ? void 0 : prevSelectedData.filter(function (item) { return item.productId !== product.productId; }); });
                                }
                                return prevSelectedVariantObject === null || prevSelectedVariantObject === void 0 ? void 0 : prevSelectedVariantObject.filter(function (v) { return v.variantId !== variant.variantId; });
                            });
                            // this will Uncheck from selected products table
                            if (uncheckFromSelected) {
                                updatedNetQuantitySubtotal = __assign({}, netQuantitySubtotal);
                                updates_2 = {};
                                delete updatedNetQuantitySubtotal[variant === null || variant === void 0 ? void 0 : variant.variantId];
                                if (ShopApplyDiscount) {
                                    delete discount_idObject[variant === null || variant === void 0 ? void 0 : variant.variantId];
                                }
                                variantId = Number((_d = variant.variantId) === null || _d === void 0 ? void 0 : _d.split("gid://shopify/ProductVariant/")[1]);
                                updates_2[variantId] = 0;
                                setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, productAddOnCart("", "update.js", updates_2)];
                                            case 1:
                                                _a.sent();
                                                return [2 /*return*/];
                                        }
                                    });
                                }); }, 800);
                                setDiscount_idObject(__assign(__assign({}, discount_idObject), (_f = {}, _f["discountOnSubTotal"] = "0", _f)));
                                setNetQuantitySubtotal(updatedNetQuantitySubtotal);
                            }
                        }
                        _g.label = 5;
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        error_6 = _g.sent();
                        return [2 /*return*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    }
    var calculateTotalVariantPrices = function (updatedNetQuantitySubtotal) {
        try {
            var totalOrderSubtotal = selectedVariantArray === null || selectedVariantArray === void 0 ? void 0 : selectedVariantArray.reduce(function (total, variant) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                var variantId = variant === null || variant === void 0 ? void 0 : variant.variantId;
                var VariantQuantity = ((_a = updatedNetQuantitySubtotal[variantId]) === null || _a === void 0 ? void 0 : _a.quantity) || 1;
                // Base unit price (fallback to B2B or raw variant price)
                var variantPrice = ((_b = B2BPriceList === null || B2BPriceList === void 0 ? void 0 : B2BPriceList[variantId]) === null || _b === void 0 ? void 0 : _b.price) || ((_c = updatedNetQuantitySubtotal[variantId]) === null || _c === void 0 ? void 0 : _c.price) || (variant === null || variant === void 0 ? void 0 : variant.variantPrice);
                // Step 1: B2B rules (Price breaks + Minimums)
                if (locationPricelistData && ((_d = Object.keys(locationPricelistData)) === null || _d === void 0 ? void 0 : _d.length) > 0) {
                    var b2bPrice = ((_e = B2BPriceList === null || B2BPriceList === void 0 ? void 0 : B2BPriceList[variantId]) === null || _e === void 0 ? void 0 : _e.price) || ((_f = updatedNetQuantitySubtotal[variantId]) === null || _f === void 0 ? void 0 : _f.price);
                    var b2bRule = getB2BQuantityRule(variantId);
                    var b2bBreaks = getB2BQuantityPriceBreaks(variantId);
                    if ((b2bRule === null || b2bRule === void 0 ? void 0 : b2bRule.Minimum) && VariantQuantity < b2bRule.Minimum && b2bPrice) {
                        variantPrice = b2bPrice;
                    }
                    if ((b2bBreaks === null || b2bBreaks === void 0 ? void 0 : b2bBreaks.length) > 0) {
                        var priceBreak = b2bBreaks.filter(function (pb) { return VariantQuantity >= pb.MinimumQuantity; }).sort(function (a, b) { return b.MinimumQuantity - a.MinimumQuantity; })[0];
                        if (priceBreak === null || priceBreak === void 0 ? void 0 : priceBreak.Price) {
                            variantPrice = priceBreak.Price;
                        }
                    }
                }
                var unitPrice = variantPrice; // Start with calculated base
                // Step 2: Apply discount if applicable
                if (ShopApplyDiscount && (discount_idObject === null || discount_idObject === void 0 ? void 0 : discount_idObject.hasOwnProperty(variantId))) {
                    var discountValueRaw = discount_idObject[variantId];
                    var discountValue = parseFloat(discountValueRaw === null || discountValueRaw === void 0 ? void 0 : discountValueRaw.toString());
                    if (!isNaN(discountValue)) {
                        if (selectedDiscountType === "percentage") {
                            if (discountValue > 0 && discountValue <= 100) {
                                unitPrice = parseFloat((_g = (variantPrice - (variantPrice * discountValue) / 100)) === null || _g === void 0 ? void 0 : _g.toFixed(2));
                            }
                        }
                        else {
                            if (discountValue >= 0 && discountValue <= variantPrice) {
                                unitPrice = parseFloat((_h = (variantPrice - discountValue)) === null || _h === void 0 ? void 0 : _h.toFixed(2));
                            }
                        }
                    }
                }
                var subtotal = parseFloat((_j = (unitPrice * VariantQuantity)) === null || _j === void 0 ? void 0 : _j.toFixed(2));
                return total + subtotal;
            }, 0);
            return totalOrderSubtotal;
        }
        catch (error) {
            return 0;
        }
    };
    var applyDiscountInSubtotale = function (subtotal) {
        var _a, _b, _c;
        try {
            var DiscountAmount = 0;
            var rawDiscountValue = discount_idObject["discountOnSubTotal"];
            var DiscountOnSubtotal = parseFloat(rawDiscountValue);
            if (!isNaN(DiscountOnSubtotal)) {
                if (selectedDiscountType === "percentage") {
                    if (DiscountOnSubtotal >= 0 && DiscountOnSubtotal <= 100) {
                        DiscountAmount = parseFloat((_a = ((subtotal * DiscountOnSubtotal) / 100)) === null || _a === void 0 ? void 0 : _a.toFixed(2));
                        var finalAmount = parseFloat((_b = (subtotal - DiscountAmount)) === null || _b === void 0 ? void 0 : _b.toFixed(2));
                        setTotalOrderAmount(finalAmount);
                    }
                }
                else {
                    if (DiscountOnSubtotal >= 0 && DiscountOnSubtotal <= subtotal) {
                        DiscountAmount = DiscountOnSubtotal;
                        var finalAmount = parseFloat((_c = (subtotal - DiscountAmount)) === null || _c === void 0 ? void 0 : _c.toFixed(2));
                        setTotalOrderAmount(finalAmount);
                    }
                }
            }
        }
        catch (error) {
            return 0;
        }
    };
    var handleQuantityAndReduxStateUpdate = function () {
        setSelectedVariantArray(function (prevSelectedVariantArray) {
            var updatedVariants = prevSelectedVariantArray === null || prevSelectedVariantArray === void 0 ? void 0 : prevSelectedVariantArray.map(function (variant) {
                var _a, _b;
                var variantMinQuantity = ((_a = netQuantitySubtotal[variant === null || variant === void 0 ? void 0 : variant.variantId]) === null || _a === void 0 ? void 0 : _a.quantity) || 1;
                if (locationPricelistData && ((_b = Object.keys(locationPricelistData)) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                    var b2bDataQuantityRule = getB2BQuantityRule(variant === null || variant === void 0 ? void 0 : variant.variantId);
                    if (b2bDataQuantityRule != null) {
                        variantMinQuantity = B2BMinQuantityRule(b2bDataQuantityRule, variantMinQuantity);
                    }
                }
                return __assign(__assign({}, variant), { quantity: variantMinQuantity });
            });
            var action = {
                payload: {
                    selectedProductData: updatedVariants,
                    isQuantityError: isQuantityError,
                    isDiscountError: isDiscountError,
                    discountKeyValueObject: discount_idObject,
                    selectedDiscountType: selectedDiscountType,
                },
                type: SalesRepDataActionType.PRODUCT_TABLE_DATA,
            };
            dispatch(action);
            return updatedVariants;
        });
    };
    // Add Button Call to show selected products
    var showSelectedProduct = function () { return __awaiter(_this, void 0, void 0, function () {
        var reduxLocationPricelistData, priceList, allVariants, catalogVariantDict_1, priceListArray_1, selectedVariantIds_1, catalogVariantDictString, updatedNetQuantitySubtotal, error_7;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 4, , 5]);
                    reduxLocationPricelistData = ((_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.locationPricelistData) || {};
                    priceList = (_b = reduxLocationPricelistData[selectedCompanyLocationId]) === null || _b === void 0 ? void 0 : _b.priceList;
                    setFinalSelectedProducts([]);
                    setFinalSelectedProducts(selectedProductArray);
                    setSearchTablePopupOpen(false);
                    setLoadMoreBtnDisable(true);
                    if (!((selectedProductArray === null || selectedProductArray === void 0 ? void 0 : selectedProductArray.length) > 0)) return [3 /*break*/, 3];
                    allVariants = selectedProductArray.flatMap(function (product) { return (product === null || product === void 0 ? void 0 : product.variants) || []; });
                    catalogVariantDict_1 = {};
                    priceListArray_1 = Object.values(priceList);
                    selectedVariantIds_1 = [];
                    allVariants === null || allVariants === void 0 ? void 0 : allVariants.forEach(function (variant) {
                        var matchingPriceEntry = priceListArray_1 === null || priceListArray_1 === void 0 ? void 0 : priceListArray_1.find(function (priceEntry) { var _a, _b; return ((_a = priceEntry === null || priceEntry === void 0 ? void 0 : priceEntry.variantId) === null || _a === void 0 ? void 0 : _a.trim()) === ((_b = variant === null || variant === void 0 ? void 0 : variant.variantId) === null || _b === void 0 ? void 0 : _b.trim()); });
                        if (matchingPriceEntry && matchingPriceEntry.catalogId) {
                            if (!catalogVariantDict_1[matchingPriceEntry.catalogId]) {
                                catalogVariantDict_1[matchingPriceEntry.catalogId] = [];
                            }
                            catalogVariantDict_1[matchingPriceEntry.catalogId].push(variant.variantId);
                            // Add only the matched variant IDs to selectedVariantIds
                            selectedVariantIds_1.push(variant);
                        }
                    });
                    if (!(((_c = Object.keys(catalogVariantDict_1)) === null || _c === void 0 ? void 0 : _c.length) > 0 && productSearchText !== "" && (searchProduct_Ids === null || searchProduct_Ids === void 0 ? void 0 : searchProduct_Ids.length) > 0)) return [3 /*break*/, 2];
                    catalogVariantDictString = JSON.stringify(catalogVariantDict_1);
                    // Call API to fetch Quantity Rules
                    return [4 /*yield*/, dispatch(GetCompanyLocationQuantityRule(selectedCompanyLocationId, catalogVariantDictString))];
                case 1:
                    // Call API to fetch Quantity Rules
                    _d.sent();
                    updatedNetQuantitySubtotal = __assign({}, netQuantitySubtotal);
                    setNetQuantitySubtotal(UpdateQuantityWithB2BQuantityRule(updatedNetQuantitySubtotal, selectedVariantIds_1));
                    _d.label = 2;
                case 2:
                    setLoadMoreBtnDisable(false);
                    _d.label = 3;
                case 3:
                    setProductSearchText("");
                    setSearchedProduct_Ids([]);
                    productAddOnCart(selectedVariantArray, "add.js");
                    return [3 /*break*/, 5];
                case 4:
                    error_7 = _d.sent();
                    return [2 /*return*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var debounceTimeoutRef = useRef({});
    function updateNetQuantitySubtotal(value, variantId, variantPrice, actionType, isReadCartData) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        if (isReadCartData === void 0) { isReadCartData = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var isLocatioProceListData, b2bDataQuantityRule, b2bDataQuantityPriceBreaks, B2B_Min_QtyRule, B2B_Max_QtyRule, B2B_Increment_QtyRule, isValidRange, isValidIncrement, currentValues, updateCartObject_1, currentVariant, currentQuantity, updatedQuantity_1, productMin, productMax, productInc, baseAdjustedQuantity, b2bPrice, matchedBreak, discountedPrice, updatedSubtotal, discountValue, discountTypeToUse, editOrderReduxData, draftOrder, numericVariantId_1, lineItem, isDiscountOnVariantId, appliedDisc, updated_NetQuantitySubtotal_1, apiResponse, _p, error_8;
            var _q, _r, _s;
            var _this = this;
            return __generator(this, function (_t) {
                switch (_t.label) {
                    case 0:
                        isLocatioProceListData = (_b = (locationPricelistData && ((_a = Object.keys(locationPricelistData)) === null || _a === void 0 ? void 0 : _a.length) > 0)) !== null && _b !== void 0 ? _b : false;
                        _t.label = 1;
                    case 1:
                        _t.trys.push([1, 9, , 10]);
                        if (!isLocatioProceListData) return [3 /*break*/, 8];
                        b2bDataQuantityRule = getB2BQuantityRule(variantId);
                        b2bDataQuantityPriceBreaks = getB2BQuantityPriceBreaks(variantId);
                        B2B_Min_QtyRule = (b2bDataQuantityRule === null || b2bDataQuantityRule === void 0 ? void 0 : b2bDataQuantityRule.Minimum) || 0;
                        B2B_Max_QtyRule = (_c = b2bDataQuantityRule === null || b2bDataQuantityRule === void 0 ? void 0 : b2bDataQuantityRule.Maximum) !== null && _c !== void 0 ? _c : null;
                        B2B_Increment_QtyRule = (_d = b2bDataQuantityRule === null || b2bDataQuantityRule === void 0 ? void 0 : b2bDataQuantityRule.Increment) !== null && _d !== void 0 ? _d : null;
                        isValidRange = Number(value) >= B2B_Min_QtyRule && (B2B_Max_QtyRule === null || Number(value) <= B2B_Max_QtyRule);
                        isValidIncrement = B2B_Increment_QtyRule === null || Number(value) % B2B_Increment_QtyRule === 0;
                        if (!(value !== "" && value !== "0" && Number(value) > 0 && isValidRange && isValidIncrement)) return [3 /*break*/, 7];
                        currentValues = __assign(__assign({}, netQuantitySubtotal), (_q = {}, _q[variantId] = {
                            quantity: Number(value),
                        }, _q));
                        setNetQuantitySubtotal(__assign({}, currentValues));
                        if (actionType == "manual") {
                            // Clear any existing timeout for this variant
                            if (debounceTimeoutRef.current[variantId]) {
                                clearTimeout(debounceTimeoutRef.current[variantId]);
                            }
                        }
                        updateCartObject_1 = {};
                        currentVariant = netQuantitySubtotal[variantId];
                        currentQuantity = (_e = currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.quantity) !== null && _e !== void 0 ? _e : 1;
                        updatedQuantity_1 = currentQuantity;
                        productMin = B2B_Min_QtyRule;
                        productMax = B2B_Max_QtyRule;
                        productInc = B2B_Increment_QtyRule !== null && B2B_Increment_QtyRule !== void 0 ? B2B_Increment_QtyRule : 1;
                        value = (_f = currentValues[variantId]) === null || _f === void 0 ? void 0 : _f.quantity;
                        if (actionType === "increaseQty") {
                            updatedQuantity_1 = productMax ? Math.min(currentQuantity + productInc, productMax) : currentQuantity + productInc;
                        }
                        else if (actionType === "decreaseQty") {
                            // Ensure quantity never goes below 1, even if productMin is 0
                            updatedQuantity_1 = Math.max(currentQuantity - productInc, Math.max(productMin, 1));
                        }
                        else {
                            baseAdjustedQuantity = Math === null || Math === void 0 ? void 0 : Math.max(Number(value), productMin);
                            updatedQuantity_1 = productMax ? Math === null || Math === void 0 ? void 0 : Math.min(baseAdjustedQuantity, productMax) : baseAdjustedQuantity;
                        }
                        b2bPrice = (_j = (_h = (_g = B2BPriceList === null || B2BPriceList === void 0 ? void 0 : B2BPriceList[variantId]) === null || _g === void 0 ? void 0 : _g.price) !== null && _h !== void 0 ? _h : currentVariant === null || currentVariant === void 0 ? void 0 : currentVariant.price) !== null && _j !== void 0 ? _j : variantPrice;
                        if ((b2bDataQuantityPriceBreaks === null || b2bDataQuantityPriceBreaks === void 0 ? void 0 : b2bDataQuantityPriceBreaks.length) > 0) {
                            matchedBreak = b2bDataQuantityPriceBreaks.filter(function (pb) { return updatedQuantity_1 >= pb.MinimumQuantity; }).sort(function (a, b) { return b.MinimumQuantity - a.MinimumQuantity; })[0];
                            if (matchedBreak === null || matchedBreak === void 0 ? void 0 : matchedBreak.Price) {
                                b2bPrice = matchedBreak.Price;
                            }
                        }
                        discountedPrice = 0;
                        updatedSubtotal = Number(b2bPrice) * updatedQuantity_1;
                        discountValue = discount_idObject === null || discount_idObject === void 0 ? void 0 : discount_idObject[variantId];
                        discountTypeToUse = selectedDiscountType;
                        // If discount not in state yet, check draftOrder line_items (for edit orders)
                        // BUT: Don't reload if discounts were manually reset (user changed discount type)
                        if ((!discountValue || discountValue === "" || discountValue === null || discountValue === undefined || discountValue === 0 || discountValue === "0") && isEditOrder && !discountsManuallyReset) {
                            editOrderReduxData = (_l = (_k = store.getState().salesRepData) === null || _k === void 0 ? void 0 : _k.editDraftOrder) !== null && _l !== void 0 ? _l : {};
                            draftOrder = editOrderReduxData === null || editOrderReduxData === void 0 ? void 0 : editOrderReduxData.draftOrderObj;
                            if ((draftOrder === null || draftOrder === void 0 ? void 0 : draftOrder.line_items) && Array.isArray(draftOrder.line_items)) {
                                numericVariantId_1 = variantId.includes("gid://shopify/ProductVariant/")
                                    ? variantId.split("gid://shopify/ProductVariant/")[1]
                                    : variantId;
                                lineItem = draftOrder.line_items.find(function (li) {
                                    var _a;
                                    var liVariantId = (_a = li === null || li === void 0 ? void 0 : li.variant_id) === null || _a === void 0 ? void 0 : _a.toString();
                                    return liVariantId === numericVariantId_1 || convertVariantIdToGraphQL(li === null || li === void 0 ? void 0 : li.variant_id) === variantId;
                                });
                                if (((_m = lineItem === null || lineItem === void 0 ? void 0 : lineItem.applied_discount) === null || _m === void 0 ? void 0 : _m.value) != null && ((_o = lineItem === null || lineItem === void 0 ? void 0 : lineItem.applied_discount) === null || _o === void 0 ? void 0 : _o.value) !== undefined) {
                                    discountValue = lineItem.applied_discount.value;
                                    discountTypeToUse = lineItem.applied_discount.value_type === "percentage" ? "percentage" : "dollar";
                                }
                            }
                        }
                        isDiscountOnVariantId = discountValue !== "" && discountValue !== null && discountValue !== undefined && discountValue !== 0 && discountValue !== "0";
                        if (isDiscountOnVariantId) {
                            appliedDisc = parseFloat(String(discountValue));
                            if (!Number.isNaN(appliedDisc)) {
                                if (discountTypeToUse === "percentage") {
                                    if (appliedDisc >= 0 && appliedDisc <= 100) {
                                        discountedPrice = b2bPrice - (b2bPrice * appliedDisc) / 100;
                                        updatedSubtotal = discountedPrice * updatedQuantity_1;
                                    }
                                }
                                else {
                                    // Fixed Amount discount: appliedDisc is per-unit discount
                                    if (appliedDisc >= 0 && appliedDisc <= b2bPrice) {
                                        // Apply per-unit discount: (price - perUnitDiscount) × quantity
                                        discountedPrice = Math === null || Math === void 0 ? void 0 : Math.max(0, b2bPrice - appliedDisc);
                                        updatedSubtotal = parseFloat((discountedPrice * updatedQuantity_1).toFixed(2));
                                    }
                                }
                            }
                        }
                        updated_NetQuantitySubtotal_1 = __assign(__assign({}, netQuantitySubtotal), (_r = {}, _r[variantId] = {
                            price: b2bPrice,
                            discountedPrice: discountedPrice,
                            quantity: updatedQuantity_1,
                            subtotal: updatedSubtotal,
                            QuantityPriceBreaks: b2bDataQuantityPriceBreaks,
                            QuantityRule: b2bDataQuantityRule,
                        }, _r));
                        updateCartObject_1 = {
                            variantId: variantId,
                            quantity: updatedQuantity_1,
                        };
                        if (!(actionType === "manual")) return [3 /*break*/, 2];
                        debounceTimeoutRef.current[variantId] = setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                            var apiResponse, _a;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        if (!(isReadCartData !== "isReadCartData")) return [3 /*break*/, 2];
                                        return [4 /*yield*/, productAddOnCart({}, "change.js", updateCartObject_1)];
                                    case 1:
                                        _a = _b.sent();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        _a = true;
                                        _b.label = 3;
                                    case 3:
                                        apiResponse = _a;
                                        if (apiResponse) {
                                            setNetQuantitySubtotal(function (prevNetQuantitySubtotal) {
                                                return __assign(__assign({}, prevNetQuantitySubtotal), updated_NetQuantitySubtotal_1);
                                            });
                                            setIsQuantityError(function (prev) {
                                                var _a;
                                                return (__assign(__assign({}, prev), (_a = {}, _a[variantId] = false, _a)));
                                            });
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); }, 1000);
                        return [3 /*break*/, 6];
                    case 2:
                        if (!(isReadCartData !== "isReadCartData")) return [3 /*break*/, 4];
                        return [4 /*yield*/, productAddOnCart({}, "change.js", updateCartObject_1)];
                    case 3:
                        _p = _t.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        _p = true;
                        _t.label = 5;
                    case 5:
                        apiResponse = _p;
                        if (apiResponse) {
                            setNetQuantitySubtotal(function () { return updated_NetQuantitySubtotal_1; });
                            setIsQuantityError(function (prev) {
                                var _a;
                                return (__assign(__assign({}, prev), (_a = {}, _a[variantId] = false, _a)));
                            });
                        }
                        _t.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        if (actionType == "manual") {
                            if (debounceTimeoutRef.current[variantId]) {
                                clearTimeout(debounceTimeoutRef.current[variantId]);
                            }
                        }
                        setAlertErrorMsg({
                            msg: B2B_Min_QtyRule !== 0 || B2B_Max_QtyRule !== null ? t("B2B_QtyRule_Error_Msg") : t("productTable_error_AlertMsg"),
                            open: true,
                        });
                        setIsQuantityError(__assign(__assign({}, isQuantityError), (_s = {}, _s[variantId] = true, _s)));
                        setNetQuantitySubtotal(function (prev) {
                            var _a;
                            return (__assign(__assign({}, prev), (_a = {}, _a[variantId] = __assign(__assign({}, prev[variantId]), { quantity: value, subtotal: 0 }), _a)));
                        });
                        _t.label = 8;
                    case 8: return [3 /*break*/, 10];
                    case 9:
                        error_8 = _t.sent();
                        return [3 /*break*/, 10];
                    case 10: return [2 /*return*/];
                }
            });
        });
    }
    var removeAllSelectedProducts = function () {
        try {
            setFinalSelectedProducts([]);
            setNetQuantitySubtotal({});
            setSelectedProductIdArray([]);
            setSelectedVariantArray([]);
            setSelectedProductArray([]);
            // makeFieldsEmpty();
            setTotalOrderAmount(0);
            setDiscount_idObject({});
            productAddOnCart({}, "clear.js"); //Clear Cart
        }
        catch (error) {
            return;
        }
    };
    // Apply B2B priceList & qty rule and qty priceBreck
    var getB2BQuantityPriceBreaks = function (variantId) {
        var _a, _b, _c, _d;
        var reduxLocationPricelistData = ((_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.locationPricelistData) || {};
        var priceList = (_b = reduxLocationPricelistData[effectiveLocationId]) === null || _b === void 0 ? void 0 : _b.priceList;
        return ((_c = priceList === null || priceList === void 0 ? void 0 : priceList[variantId]) === null || _c === void 0 ? void 0 : _c.QuantityPriceBreaks) || ((_d = netQuantitySubtotal[variantId]) === null || _d === void 0 ? void 0 : _d.QuantityPriceBreaks) || [];
    };
    var getB2BPrice = function (variantId) {
        var _a, _b, _c, _d;
        var reduxLocationPricelistData = ((_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.locationPricelistData) || {};
        var priceList = (_b = reduxLocationPricelistData[effectiveLocationId]) === null || _b === void 0 ? void 0 : _b.priceList;
        return ((_c = priceList === null || priceList === void 0 ? void 0 : priceList[variantId]) === null || _c === void 0 ? void 0 : _c.price) || ((_d = netQuantitySubtotal[variantId]) === null || _d === void 0 ? void 0 : _d.price) || 0;
    };
    var getB2BQuantityRule = function (variantId) {
        var _a, _b, _c, _d;
        var reduxLocationPricelistData = ((_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.locationPricelistData) || {};
        var priceList = (_b = reduxLocationPricelistData[effectiveLocationId]) === null || _b === void 0 ? void 0 : _b.priceList;
        return ((_c = priceList === null || priceList === void 0 ? void 0 : priceList[variantId]) === null || _c === void 0 ? void 0 : _c.QuantityRule) || ((_d = netQuantitySubtotal[variantId]) === null || _d === void 0 ? void 0 : _d.QuantityRule) || null;
    };
    var B2BMinQuantityRule = function (QuantityRule, variantQuantity) {
        if (QuantityRule && (QuantityRule === null || QuantityRule === void 0 ? void 0 : QuantityRule.Minimum) && variantQuantity < (QuantityRule === null || QuantityRule === void 0 ? void 0 : QuantityRule.Minimum)) {
            variantQuantity = QuantityRule === null || QuantityRule === void 0 ? void 0 : QuantityRule.Minimum;
        }
        return variantQuantity;
    };
    var B2BUpdatedSubTotal = function (Quantity, QuantityPriceBreaks, updatedVarientSubTotal) {
        if (QuantityPriceBreaks && (QuantityPriceBreaks === null || QuantityPriceBreaks === void 0 ? void 0 : QuantityPriceBreaks.length) > 0) {
            QuantityPriceBreaks.sort(function (a, b) { return b.MinimumQuantity - a.MinimumQuantity; });
            for (var _i = 0, QuantityPriceBreaks_1 = QuantityPriceBreaks; _i < QuantityPriceBreaks_1.length; _i++) {
                var priceBreak = QuantityPriceBreaks_1[_i];
                if (Quantity >= (priceBreak === null || priceBreak === void 0 ? void 0 : priceBreak.MinimumQuantity)) {
                    updatedVarientSubTotal = Number(Quantity) * (priceBreak === null || priceBreak === void 0 ? void 0 : priceBreak.Price);
                    break;
                }
            }
        }
        return updatedVarientSubTotal;
    };
    var getB2BLocationPrice = function (variant, variantId) {
        var _a, _b;
        var B2BPrice = ((_a = B2BPriceList === null || B2BPriceList === void 0 ? void 0 : B2BPriceList[variantId]) === null || _a === void 0 ? void 0 : _a.price) || ((_b = netQuantitySubtotal[variant === null || variant === void 0 ? void 0 : variant.variantId]) === null || _b === void 0 ? void 0 : _b.price);
        var b2bDataQuantityPriceBreaks = getB2BQuantityPriceBreaks(variantId);
        var variantQuantity = variant === null || variant === void 0 ? void 0 : variant.quantity;
        var variantPrice = B2BPrice || 1;
        if (b2bDataQuantityPriceBreaks && (b2bDataQuantityPriceBreaks === null || b2bDataQuantityPriceBreaks === void 0 ? void 0 : b2bDataQuantityPriceBreaks.length) > 0) {
            b2bDataQuantityPriceBreaks.sort(function (a, b) { return b.MinimumQuantity - a.MinimumQuantity; });
            for (var _i = 0, b2bDataQuantityPriceBreaks_2 = b2bDataQuantityPriceBreaks; _i < b2bDataQuantityPriceBreaks_2.length; _i++) {
                var priceBreak = b2bDataQuantityPriceBreaks_2[_i];
                if (variantQuantity >= priceBreak.MinimumQuantity) {
                    variantPrice = priceBreak === null || priceBreak === void 0 ? void 0 : priceBreak.Price;
                    break;
                }
            }
        }
        return variantPrice;
    };
    var IncrementB2BQuantity = function (variant, variantId) {
        var quantity = variant === null || variant === void 0 ? void 0 : variant.quantity;
        var b2bDataQuantityRule = getB2BQuantityRule(variantId);
        if (b2bDataQuantityRule) {
            var productIncrement = b2bDataQuantityRule === null || b2bDataQuantityRule === void 0 ? void 0 : b2bDataQuantityRule.Increment;
            if (quantity % productIncrement !== 0) {
                var remainder = quantity % productIncrement;
                var adjustment = productIncrement - remainder;
                var updatedQuantity = quantity + adjustment;
                quantity = updatedQuantity;
            }
        }
        return quantity;
    };
    var UpdateQuantityWithB2BQuantityRule = function (netQuantitySubtotal, variants) {
        var _a, _b, _c;
        if (locationPricelistData && ((_a = Object.keys(locationPricelistData)) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var reduxLocationPricelistData = ((_b = store.getState().salesRepData) === null || _b === void 0 ? void 0 : _b.locationPricelistData) || {};
            var priceList_1 = (_c = reduxLocationPricelistData[effectiveLocationId]) === null || _c === void 0 ? void 0 : _c.priceList;
            variants === null || variants === void 0 ? void 0 : variants.forEach(function (variantToAdd) {
                var _a, _b;
                var VariantId = variantToAdd === null || variantToAdd === void 0 ? void 0 : variantToAdd.variantId;
                var variantPrice = ((_a = priceList_1 === null || priceList_1 === void 0 ? void 0 : priceList_1[VariantId]) === null || _a === void 0 ? void 0 : _a.price) || ((_b = netQuantitySubtotal[VariantId]) === null || _b === void 0 ? void 0 : _b.price) || (variantToAdd === null || variantToAdd === void 0 ? void 0 : variantToAdd.variantPrice);
                var variantMinQuantity = 1;
                // Check if the variant exists in the priceList
                if ((priceList_1 === null || priceList_1 === void 0 ? void 0 : priceList_1[VariantId]) || netQuantitySubtotal[VariantId]) {
                    var b2bDataQuantityRule = getB2BQuantityRule(VariantId);
                    var b2bDataQuantityPriceBreaks = getB2BQuantityPriceBreaks(VariantId);
                    if (b2bDataQuantityRule != null) {
                        variantMinQuantity = B2BMinQuantityRule(b2bDataQuantityRule, variantMinQuantity);
                    }
                    netQuantitySubtotal[VariantId] = {
                        price: variantPrice,
                        quantity: variantMinQuantity,
                        subtotal: Number(variantMinQuantity) * variantPrice,
                        QuantityPriceBreaks: b2bDataQuantityPriceBreaks,
                        QuantityRule: b2bDataQuantityRule,
                    };
                }
            });
        }
        return netQuantitySubtotal;
    };
    // B2B Pricelist mapping shows in UI
    var showB2BQtyCataloguePrice = function (variantId, variantQuantity, b2bPrice) {
        var _a;
        if (locationPricelistData && ((_a = Object.keys(locationPricelistData)) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var b2bDataQuantityPriceBreaks = getB2BQuantityPriceBreaks(variantId);
            if (b2bDataQuantityPriceBreaks && (b2bDataQuantityPriceBreaks === null || b2bDataQuantityPriceBreaks === void 0 ? void 0 : b2bDataQuantityPriceBreaks.length) > 0) {
                var relevantPriceBreak = b2bDataQuantityPriceBreaks === null || b2bDataQuantityPriceBreaks === void 0 ? void 0 : b2bDataQuantityPriceBreaks.filter(function (priceBreak) { return (priceBreak === null || priceBreak === void 0 ? void 0 : priceBreak.MinimumQuantity) <= variantQuantity; }).sort(function (a, b) { return (b === null || b === void 0 ? void 0 : b.MinimumQuantity) - (a === null || a === void 0 ? void 0 : a.MinimumQuantity); })[0];
                if (relevantPriceBreak) {
                    return relevantPriceBreak === null || relevantPriceBreak === void 0 ? void 0 : relevantPriceBreak.Price.toFixed(2);
                }
                else if (b2bPrice) {
                    return b2bPrice;
                }
            }
            else if (b2bPrice) {
                return b2bPrice;
            }
        }
        return null;
    };
    var readCartProducts = function () { return __awaiter(_this, void 0, void 0, function () {
        var responseGetCart, productsArray_1, updatedSelectedProductIdObject;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    // Cart products should still be read/shown even if locationPricelistData isn't available yet for this location
                    if (!effectiveLocationId) {
                        console.warn("readCartProducts: No location selected, cannot read cart");
                        return [2 /*return*/];
                    }
                    isLoading.next(true);
                    return [4 /*yield*/, dispatch(gettingCartData())];
                case 1:
                    responseGetCart = _d.sent();
                    if ((responseGetCart === null || responseGetCart === void 0 ? void 0 : responseGetCart.status) === 200 && ((_b = (_a = responseGetCart === null || responseGetCart === void 0 ? void 0 : responseGetCart.data) === null || _a === void 0 ? void 0 : _a.items) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                        // Reset state before reading (like regular order) to avoid duplicates
                        if (isEditOrder) {
                            setFinalSelectedProducts([]);
                            setSelectedProductArray([]);
                            setSelectedProductIdArray([]);
                            setSelectedVariantArray([]);
                            setNetQuantitySubtotal({});
                        }
                        setGetProductsLoading(true);
                        productsArray_1 = handleMakeFormatArray((_c = responseGetCart === null || responseGetCart === void 0 ? void 0 : responseGetCart.data) === null || _c === void 0 ? void 0 : _c.items);
                        setFinalSelectedProducts(productsArray_1);
                        setSelectedProductArray(productsArray_1);
                        updatedSelectedProductIdObject = productsArray_1 === null || productsArray_1 === void 0 ? void 0 : productsArray_1.map(function (_a) {
                            var productId = _a.productId;
                            return productId;
                        });
                        setSelectedProductIdArray(updatedSelectedProductIdObject);
                        handleQuantityAndReduxStateUpdate();
                    }
                    isLoading.next(false);
                    setGetProductsLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    // Parse Cart.js API response
    var handleMakeFormatArray = function (cartProducts) {
        var _a, _b;
        var formattedOutput = [];
        var newSelectedVariants = [];
        var B2BPrice = 0;
        var B2BQuantity = 0;
        cartProducts === null || cartProducts === void 0 ? void 0 : cartProducts.forEach(function (inputObject) {
            var _a, _b, _c;
            var B2BVarientID = "gid://shopify/ProductVariant/" + (inputObject === null || inputObject === void 0 ? void 0 : inputObject.variant_id);
            if (locationPricelistData && ((_a = Object.keys(locationPricelistData)) === null || _a === void 0 ? void 0 : _a.length) > 0 && (B2BPriceList === null || B2BPriceList === void 0 ? void 0 : B2BPriceList[B2BVarientID])) {
                B2BPrice = getB2BLocationPrice(inputObject, B2BVarientID);
                B2BQuantity = IncrementB2BQuantity(inputObject, B2BVarientID);
            }
            var existingProductIndex = formattedOutput.findIndex(function (product) { return product.productId === "gid://shopify/Product/" + inputObject.product_id; });
            var formattedVariant = {
                variantId: B2BVarientID,
                variantPrice: B2BPrice != 0 ? B2BPrice : inputObject.final_price / 100,
                imageUrl: ((_b = inputObject === null || inputObject === void 0 ? void 0 : inputObject.featured_image) === null || _b === void 0 ? void 0 : _b.url) || "",
                currency: shopCurrency,
                inventoryQuantity: inputObject === null || inputObject === void 0 ? void 0 : inputObject.quantity,
                sku: inputObject === null || inputObject === void 0 ? void 0 : inputObject.sku,
                title: inputObject.variant_title || "Default Title",
                quantityAvailable: "NA",
                availableForSale: true,
                quantity: B2BQuantity != 0 ? B2BQuantity : inputObject === null || inputObject === void 0 ? void 0 : inputObject.quantity,
                wholesalePrice: inputObject.final_price / 100,
            };
            if (existingProductIndex !== -1) {
                // If the product already exists, check if this variant already exists to avoid duplicates
                var existingVariantIndex = formattedOutput[existingProductIndex].variants.findIndex(function (v) { return v.variantId === formattedVariant.variantId; });
                if (existingVariantIndex === -1) {
                    // Variant doesn't exist, add it
                    formattedOutput[existingProductIndex].variants.push(formattedVariant);
                    newSelectedVariants.push(formattedVariant);
                }
                else {
                    // Variant already exists - this shouldn't happen if cart API is correct
                    // But if it does, use the cart quantity (don't add quantities, as cart should already have correct total)
                    // Replace the existing variant with the new one to ensure we use the latest data from cart
                    formattedOutput[existingProductIndex].variants[existingVariantIndex] = formattedVariant;
                    // Update the variant in newSelectedVariants if it was already added
                    var variantIndexInNew = newSelectedVariants.findIndex(function (v) { return v.variantId === formattedVariant.variantId; });
                    if (variantIndexInNew !== -1) {
                        newSelectedVariants[variantIndexInNew] = formattedVariant;
                    }
                    else {
                        newSelectedVariants.push(formattedVariant);
                    }
                }
            }
            else {
                // If the product doesn't exist, create a new product and add it to the formattedOutput
                var productModel = {
                    productId: "gid://shopify/Product/" + inputObject.product_id,
                    title: inputObject.title,
                    variants: [formattedVariant],
                    imageUrl: ((_c = inputObject.featured_image) === null || _c === void 0 ? void 0 : _c.url) || null,
                };
                formattedOutput.push(productModel);
                newSelectedVariants.push(formattedVariant);
            }
        });
        // Check if any products from cart are missing from price list (for banner display)
        // Only check for edit orders when price list is available
        var priceListForBanner = (_a = locationPricelistData[effectiveLocationId]) === null || _a === void 0 ? void 0 : _a.priceList;
        var hasProductsMissingFromPriceList = false;
        if (isEditOrder && priceListForBanner && formattedOutput.length > 0) {
            hasProductsMissingFromPriceList = formattedOutput.some(function (product) { return !Object.values(priceListForBanner).some(function (item) { return (item === null || item === void 0 ? void 0 : item.productId) === (product === null || product === void 0 ? void 0 : product.productId); }); });
        }
        // Store flag in Redux editDraftOrder state for banner display (update even if false to clear previous state)
        // Debounced: the price list can be fetched/merged across multiple re-runs of this function while
        // it settles, which was flipping this flag true/false/true and making the banner flicker
        if (isEditOrder) {
            if (missingPriceListBannerTimerRef.current) {
                clearTimeout(missingPriceListBannerTimerRef.current);
            }
            missingPriceListBannerTimerRef.current = setTimeout(function () {
                var _a, _b;
                var editOrderReduxData = (_b = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.editDraftOrder) !== null && _b !== void 0 ? _b : {};
                var updateReduxState = {
                    payload: __assign(__assign({}, editOrderReduxData), { hasProductsMissingFromPriceList: hasProductsMissingFromPriceList }),
                    type: SalesRepDataActionType.EDIT_DRAFT_ORDER,
                };
                dispatch(updateReduxState);
            }, 700);
        }
        var filterWithCatalogueProducts = updateProductsWithB2bPriceList(formattedOutput);
        // Filter variants to only include those that are in the filtered products (products in price list)
        // This ensures subtotal calculation only includes visible products
        // For edit orders, keep every product/variant from the order even if it's missing from the price list -
        // the banner above already flags that, so don't also hide the product
        var priceList = (_b = locationPricelistData[effectiveLocationId]) === null || _b === void 0 ? void 0 : _b.priceList;
        var filteredVariants = newSelectedVariants || [];
        if (!isEditOrder && priceList && Object.keys(priceList).length > 0 && filterWithCatalogueProducts && filterWithCatalogueProducts.length > 0 && formattedOutput && formattedOutput.length > 0 && filterWithCatalogueProducts.length < formattedOutput.length) {
            // Products were filtered, so filter variants too
            var filteredVariantIds_1 = new Set();
            filterWithCatalogueProducts.forEach(function (product) {
                if (product && (product === null || product === void 0 ? void 0 : product.variants) && Array.isArray(product.variants)) {
                    product.variants.forEach(function (variant) {
                        if (variant && (variant === null || variant === void 0 ? void 0 : variant.variantId)) {
                            filteredVariantIds_1.add(variant.variantId);
                        }
                    });
                }
            });
            filteredVariants = (newSelectedVariants || []).filter(function (variant) {
                return variant && (variant === null || variant === void 0 ? void 0 : variant.variantId) && filteredVariantIds_1.has(variant.variantId);
            });
            // Clean up netQuantitySubtotal to remove entries for filtered-out variants
            if (isEditOrder) {
                setNetQuantitySubtotal(function (prevNetQuantitySubtotal) {
                    var cleanedSubtotal = {};
                    if (prevNetQuantitySubtotal && typeof prevNetQuantitySubtotal === 'object' && filteredVariants && filteredVariants.length > 0) {
                        filteredVariants.forEach(function (variant) {
                            if (variant && (variant === null || variant === void 0 ? void 0 : variant.variantId)) {
                                var variantId = variant.variantId;
                                if (prevNetQuantitySubtotal[variantId]) {
                                    cleanedSubtotal[variantId] = prevNetQuantitySubtotal[variantId];
                                }
                            }
                        });
                    }
                    // If filteredVariants is empty, return empty object to clear all subtotals
                    return cleanedSubtotal;
                });
            }
        }
        // Update selectedVariantArray state with filtered variants only
        // For edit mode, replace instead of append to avoid duplicates
        if (isEditOrder) {
            setSelectedVariantArray(filteredVariants);
        }
        else {
            setSelectedVariantArray(function (prevSelectedVariantObject) { return __spreadArray(__spreadArray([], prevSelectedVariantObject, true), filteredVariants, true); });
        }
        setSelectedProductArray(isEditOrder ? formattedOutput : filterWithCatalogueProducts);
        // Update net quantity subtotal for filtered variants only
        filteredVariants === null || filteredVariants === void 0 ? void 0 : filteredVariants.forEach(function (formattedVariant) {
            var _a;
            if (locationPricelistData && ((_a = Object.keys(locationPricelistData)) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                var variantMinQuantity = (formattedVariant === null || formattedVariant === void 0 ? void 0 : formattedVariant.quantity) || 1;
                var formattedVariantId = formattedVariant === null || formattedVariant === void 0 ? void 0 : formattedVariant.variantId;
                var formattedVariantPrice = formattedVariant === null || formattedVariant === void 0 ? void 0 : formattedVariant.variantPrice;
                var b2bDataQuantityRule = getB2BQuantityRule(formattedVariantId);
                if (b2bDataQuantityRule != null) {
                    variantMinQuantity = B2BMinQuantityRule(b2bDataQuantityRule, variantMinQuantity);
                }
                updateNetQuantitySubtotal(variantMinQuantity, formattedVariantId, formattedVariantPrice, "manual", "isReadCartData");
            }
        });
        return isEditOrder ? formattedOutput : filterWithCatalogueProducts;
    };
    var handleAlertMsgClose = function (event, reason) {
        if (reason === "clickaway") {
            return;
        }
        setAlertErrorMsg({ msg: "", open: false });
    };
    // line item discount
    var appliedDiscount = function (e, variant) {
        var _a, _b, _c;
        var value = e.target.value;
        var variantId = variant === null || variant === void 0 ? void 0 : variant.variantId;
        try {
            var price = Number(getB2BPrice(variantId));
            if (!variantId) {
                setAlertErrorMsg({ msg: t("customerInvoice_AlertErrorMsg"), open: true });
                return;
            }
            var quantity_1 = ((_a = netQuantitySubtotal[variantId]) === null || _a === void 0 ? void 0 : _a.quantity) || 1;
            if (value !== "") {
                var numberValue = Number(value);
                setDiscount_idObject(function (prev) {
                    var _a;
                    return (__assign(__assign({}, prev), (_a = {}, _a[variantId] = value, _a)));
                });
                if (selectedDiscountType === "percentage") {
                    if (numberValue > 0 && numberValue <= 100) {
                        var discountedUnitPrice_1 = parseFloat((_b = (price - (price * numberValue) / 100)) === null || _b === void 0 ? void 0 : _b.toFixed(2));
                        var subtotal_1 = parseFloat((_c = (discountedUnitPrice_1 * quantity_1)) === null || _c === void 0 ? void 0 : _c.toFixed(2));
                        setNetQuantitySubtotal(function (prev) {
                            var _a;
                            return (__assign(__assign({}, prev), (_a = {}, _a[variantId] = __assign(__assign({}, prev[variantId]), { discountedPrice: discountedUnitPrice_1, subtotal: subtotal_1 }), _a)));
                        });
                        setIsDiscountError(function (prev) {
                            var _a;
                            return (__assign(__assign({}, prev), (_a = {}, _a[variantId] = false, _a)));
                        });
                    }
                    else {
                        setIsDiscountError(function (prev) {
                            var _a;
                            return (__assign(__assign({}, prev), (_a = {}, _a[variantId] = true, _a)));
                        });
                    }
                }
                else {
                    // Fixed Amount discount: value is per-unit discount
                    if (numberValue >= 0 && numberValue <= price) {
                        // Apply per-unit discount: (price - perUnitDiscount) × quantity
                        var discountedUnitPrice_2 = parseFloat((price - numberValue).toFixed(2));
                        var subtotal_2 = parseFloat((discountedUnitPrice_2 * quantity_1).toFixed(2));
                        setNetQuantitySubtotal(function (prev) {
                            var _a;
                            return (__assign(__assign({}, prev), (_a = {}, _a[variantId] = __assign(__assign({}, prev[variantId]), { discountedPrice: discountedUnitPrice_2, subtotal: subtotal_2 }), _a)));
                        });
                        setIsDiscountError(function (prev) {
                            var _a;
                            return (__assign(__assign({}, prev), (_a = {}, _a[variantId] = false, _a)));
                        });
                    }
                    else {
                        setIsDiscountError(function (prev) {
                            var _a;
                            return (__assign(__assign({}, prev), (_a = {}, _a[variantId] = true, _a)));
                        });
                    }
                }
            }
            else {
                // Clear discount value
                var subtotal_3 = parseFloat((price * quantity_1).toFixed(2));
                setNetQuantitySubtotal(function (prev) {
                    var _a;
                    return (__assign(__assign({}, prev), (_a = {}, _a[variantId] = __assign(__assign({}, prev[variantId]), { discountedPrice: 0, subtotal: subtotal_3, quantity: quantity_1 }), _a)));
                });
                setDiscount_idObject(function (prev) {
                    var _a;
                    return (__assign(__assign({}, prev), (_a = {}, _a[variantId] = "", _a)));
                });
                setIsDiscountError(function (prev) {
                    var _a;
                    return (__assign(__assign({}, prev), (_a = {}, _a[variantId] = false, _a)));
                });
            }
        }
        catch (error) {
            console.error("Error in appliedDiscount:", error);
        }
    };
    var handleSelectChangeForDiscountType = function (event) {
        var newType = event.target.value;
        if (newType !== selectedDiscountType) {
            setPendingDiscountType(newType);
            setDiscountAlertBox(true);
        }
    };
    var handleCancelChangeDiscountType = function () {
        setDiscountAlertBox(false);
    };
    var handleConfirmChangeDiscountType = function () {
        setDiscountAlertBox(false);
        setSelectedDiscountType(pendingDiscountType);
        // Reset subtotal for all variants with original price
        finalSelectedProducts === null || finalSelectedProducts === void 0 ? void 0 : finalSelectedProducts.forEach(function (product) {
            var _a;
            (_a = product === null || product === void 0 ? void 0 : product.variants) === null || _a === void 0 ? void 0 : _a.forEach(function (variant) {
                var _a, _b, _c, _d;
                var variantId = variant.variantId;
                var basePrice = (_c = (_b = (_a = B2BPriceList === null || B2BPriceList === void 0 ? void 0 : B2BPriceList[variantId]) === null || _a === void 0 ? void 0 : _a.price) !== null && _b !== void 0 ? _b : variant === null || variant === void 0 ? void 0 : variant.variantPrice) !== null && _c !== void 0 ? _c : 0;
                var quantity = ((_d = netQuantitySubtotal[variantId]) === null || _d === void 0 ? void 0 : _d.quantity) || 1;
                setNetQuantitySubtotal(function (prev) {
                    var _a;
                    return (__assign(__assign({}, prev), (_a = {}, _a[variantId] = __assign(__assign({}, prev[variantId]), { price: basePrice, discountedPrice: 0, subtotal: basePrice * quantity }), _a)));
                });
            });
        });
        // Clear applied discounts and errors
        setDiscount_idObject({});
        setIsDiscountError({});
        // Set flag to prevent useEffect from re-loading discounts from draftOrder
        setDiscountsManuallyReset(true);
    };
    var handleDiscountChange = function (e) {
        var discountValue = parseFloat(e.target.value);
        if (e.target.value !== "") {
            var isValidDiscount = selectedDiscountType === "percentage" ? discountValue >= 0 && discountValue <= 100 : !isNaN(discountValue) && discountValue <= masterSubTotal && discountValue >= 0;
            setDiscountState(isValidDiscount ? discountValue : "", !isValidDiscount);
        }
        else {
            setDiscountState("", false);
        }
    };
    var setDiscountState = function (value, isError) {
        var _a, _b;
        // Ensure discountOnSubTotal is always a string for consistency
        var stringValue = value !== "" && value !== null && value !== undefined ? String(value) : value;
        setDiscount_idObject(__assign(__assign({}, discount_idObject), (_a = {}, _a["discountOnSubTotal"] = stringValue, _a)));
        setIsDiscountError(__assign(__assign({}, isDiscountError), (_b = {}, _b["discountOnSubTotal"] = isError, _b)));
    };
    var isNotEmpty = function (params) {
        if (params !== null && params !== undefined) {
            return true;
        }
        else {
            return false;
        }
    };
    return {
        totalOrderAmount: totalOrderAmount,
        handleSearchProductData: handleSearchProductData,
        makeFieldsEmpty: makeFieldsEmpty,
        productSearchText: productSearchText,
        handleKeyDown: handleKeyDown,
        handleProductTableSearchPopup: handleProductTableSearchPopup,
        shopCurrency: shopCurrency,
        currency: currency,
        handleSearchTextChange: handleSearchTextChange,
        searchTablePopupOpen: searchTablePopupOpen,
        productsArray: productsArray,
        getProductsLoading: getProductsLoading,
        selectedProductArray: selectedProductArray,
        checkUncheckProductVariant: checkUncheckProductVariant,
        selectedVariantArray: selectedVariantArray,
        selectedProductIdArray: selectedProductIdArray,
        showSelectedProduct: showSelectedProduct,
        netQuantitySubtotal: netQuantitySubtotal,
        updateNetQuantitySubtotal: updateNetQuantitySubtotal,
        finalSelectedProducts: finalSelectedProducts,
        closePopupForSearchProductData: closePopupForSearchProductData,
        removeAllSelectedProducts: removeAllSelectedProducts,
        handleNextClick: handleNextClick,
        handlePrevClick: handlePrevClick,
        pageInfo: pageInfo,
        handleAlertMsgClose: handleAlertMsgClose,
        alertErrorMsg: alertErrorMsg,
        isQuantityError: isQuantityError,
        t: t,
        handleViewPricingPopup: handleViewPricingPopup,
        viewPricingPopupOpen: viewPricingPopupOpen,
        setViewPricingPopupOpen: setViewPricingPopupOpen,
        productName: productName,
        productVariantID: productVariantID,
        showB2BQtyCataloguePrice: showB2BQtyCataloguePrice,
        propsFromCreateOrderParentTab: propsFromCreateOrderParentTab,
        locationPricelistData: locationPricelistData,
        tableContainerRef: tableContainerRef,
        isUpdatedCart: isUpdatedCart,
        readCartProducts: readCartProducts,
        isRemoveCartPopup: isRemoveCartPopup,
        setIsRemoveCartPopup: setIsRemoveCartPopup,
        loadMoreBtnDisable: loadMoreBtnDisable,
        discount_idObject: discount_idObject,
        isDiscountError: isDiscountError,
        isNotEmpty: isNotEmpty,
        appliedDiscount: appliedDiscount,
        handleSelectChangeForDiscountType: handleSelectChangeForDiscountType,
        handleCancelChangeDiscountType: handleCancelChangeDiscountType,
        handleConfirmChangeDiscountType: handleConfirmChangeDiscountType,
        discountAlertBox: discountAlertBox,
        selectedDiscountType: selectedDiscountType,
        ShopApplyDiscount: ShopApplyDiscount,
        handleDiscountChange: handleDiscountChange,
        hoveredIconIndex: hoveredIconIndex,
        setHoveredIconIndex: setHoveredIconIndex,
        loadMoreProducts: loadMoreProducts,
    };
}
export function cssConstants() {
    var QuantityCatelogBtns = {
        border: "1px solid #E0E0E0",
        mt: "8px",
        color: "black",
        textTransform: "capitalize",
    };
    return {
        QuantityCatelogBtns: QuantityCatelogBtns,
    };
}
